import type { LocaleMessageBundle } from '../../types'

export const salesMessages: LocaleMessageBundle = {
  vi: {
    'setting.billiardLight.add': 'Thêm thiết bị',
    'setting.billiardLight.edit': 'Cập nhật thiết bị đèn',
    'setting.billiardLight.delete': 'Xóa thiết bị đèn',
    'setting.billiardLight.deleteConfirm': 'Bạn có chắc muốn xóa thiết bị “{name}”?',
    'setting.billiardLight.created': 'Đã thêm thiết bị đèn.',
    'setting.billiardLight.updated': 'Đã cập nhật thiết bị đèn.',
    'setting.billiardLight.deleted': 'Đã xóa thiết bị đèn.',
    'setting.billiardLight.unassigned': 'Chưa gán bàn',
    'setting.billiardLight.online': 'Đang kết nối',
    'setting.billiardLight.offline': 'Mất kết nối',
    'setting.billiardLight.neverConnected': 'Chưa kết nối',
    'setting.billiardLight.tokenHint': 'Để trống để hệ thống tự sinh khi thêm mới; nhập giá trị mới để đổi mã.',
    'setting.billiardLight.generatedToken': 'Lưu mã này vào firmware. Mã chỉ hiển thị một lần:',
    'setting.billiardLight.fields.name': 'Tên thiết bị',
    'setting.billiardLight.fields.mac': 'MAC thiết bị ESP',
    'setting.billiardLight.fields.ip': 'Địa chỉ IP',
    'setting.billiardLight.fields.table': 'Bàn được gán',
    'setting.billiardLight.fields.connection': 'Kết nối',
    'setting.billiardLight.fields.light': 'Đèn',
    'setting.billiardLight.fields.lastSeen': 'Kết nối gần nhất',
    'setting.billiardLight.fields.token': 'Mã bảo mật thiết bị',
    'setting.billiardLight.fields.active': 'Cho phép thiết bị hoạt động',
    'sales.table.light.configure': 'Cấu hình đèn bàn',
    'sales.table.light.mac': 'MAC thiết bị ESP',
    'sales.table.light.token': 'Mã bảo mật thiết bị',
    'sales.table.light.tokenHint': 'Để trống khi tạo mới để hệ thống sinh mã; nhập mã mới nếu muốn thay đổi.',
    'sales.table.light.generatedToken': 'Lưu mã này vào firmware, hệ thống chỉ hiển thị một lần:',
    'sales.pos.light.on': 'Đèn bật',
    'sales.pos.light.off': 'Đèn tắt',
    'sales.pos.light.offline': 'Đèn mất kết nối',
    'payment.confirm.paymentInfo': 'Thông tin thanh toán',
    'payment.confirm.pointValue': 'Tiền quy đổi từ điểm thưởng',
    'payment.confirm.actualPayer': 'Người thực tế thanh toán',
    'payment.confirm.customerPaidAmount': 'Tiền khách hàng thanh toán',
    'payment.confirm.currencyUnit': 'đ',
    'payment.confirm.refreshPaidAmount': 'Cập nhật số tiền',
    'payment.confirm.debt': 'Ghi nợ',
    'payment.confirm.change': 'Tiền thừa trả khách',
    'payment.confirm.title': 'Xác nhận thanh toán',
    'payment.confirm.orderCode': 'Mã đơn hàng',
    'payment.confirm.table': 'Bàn',
    'payment.confirm.subtotal': 'Tổng tiền hàng',
    'payment.confirm.discount': 'Giảm giá',
    'payment.confirm.vouchers': 'Voucher áp dụng',
    'payment.confirm.surcharge': 'Phụ thu',
    'payment.confirm.total': 'Tổng thanh toán',
    'payment.confirm.paid': 'Đã thanh toán',
    'payment.confirm.remaining': 'Còn phải thanh toán',
    'payment.confirm.method': 'Phương thức thanh toán',
    'payment.confirm.payers': 'Khách hàng thanh toán',
    'payment.confirm.commonPayer': 'Một người thanh toán cho tất cả',
    'payment.confirm.commonPayerHint':
      'Chọn một khách hàng để thanh toán toàn bộ phần tiền của những người bên dưới.',
    'payment.confirm.pointsUse': 'Điểm sử dụng',
    'payment.confirm.pointsAvailable': 'Hiện có {points} điểm',
    'payment.confirm.pointsConverted': 'Quy đổi {amount}đ',
    'payment.confirm.pointsOfflineNotice':
      'Chưa dùng được điểm thưởng khi đang ngoại tuyến. Khách sẽ thanh toán đủ bằng tiền mặt, điểm không bị trừ.',
    'payment.confirm.errors.pointsBelowMinimum':
      'Cần sử dụng ít nhất {points} điểm cho mỗi hóa đơn.',
    'payment.confirm.errors.pointsNotMultiple': 'Số điểm sử dụng phải là bội số của {points}.',
    'payment.confirm.errors.insufficientPoints':
      'Tổng điểm sử dụng vượt quá số điểm hiện có của khách hàng.',
    'payment.confirm.errors.pointsAboveMaximum':
      'Chỉ được sử dụng tối đa {points} điểm cho mỗi hóa đơn.',
    'payment.confirm.errors.pointsPercentExceeded':
      'Giá trị điểm không được vượt quá {percent}% giá trị hóa đơn.',
    'payment.confirm.creditLimitTitle': 'Cảnh báo công nợ quá hạn',
    'payment.confirm.creditLimitCurrentDebt': 'Đang nợ',
    'payment.confirm.creditLimitProjected': 'Công nợ dự kiến',
    'payment.confirm.creditLimitLimit': 'Hạn mức nợ',
    'payment.confirm.creditLimitExceeded': '{debt} (vượt {exceeded})',
    'payment.confirm.creditLimitOffline':
      'Số liệu công nợ lấy từ dữ liệu tải khi offline, có thể chưa cập nhật mới nhất.',
    'payment.confirm.creditLimitBlocked':
      'Vui lòng thu đủ hoặc giảm số tiền ghi nợ trước khi thanh toán.',
    'payment.confirm.errors.creditLimitExceeded':
      'Công nợ dự kiến của {customer} ({debt}) vượt hạn mức nợ ({limit}). Vui lòng thu đủ hoặc giảm số tiền ghi nợ.',
    'payment.confirm.pay': 'Thanh toán (F2)',
    'payment.confirm.payAndPrint': 'Thanh toán & In (F1)',
    'sales.pos.bookings.title': 'Quản lý đặt bàn',
    'sales.pos.bookings.posHint': 'Theo dõi bàn đã đặt, khách quá giờ và nhận bàn ngay tại POS.',
    'sales.pos.bookings.create': 'Đặt bàn',
    'sales.pos.bookings.createTitle': 'Tạo đặt bàn',
    'sales.pos.bookings.editTitle': 'Cập nhật đặt bàn',
    'sales.pos.bookings.detailTitle': 'Chi tiết đặt bàn',
    'sales.pos.bookings.confirm': 'Xác nhận đặt bàn',
    'sales.pos.bookings.search': 'Tìm mã, khách, số điện thoại hoặc bàn',
    'sales.pos.bookings.empty': 'Không có đặt bàn phù hợp.',
    'sales.pos.bookings.pagination.total': 'Tổng {total} lượt đặt bàn',
    'sales.pos.bookings.columns.booking': 'Mã và khách hàng',
    'sales.pos.bookings.columns.tables': 'Bàn đặt',
    'sales.pos.bookings.columns.actions': 'Thao tác',
    'sales.pos.bookings.walkIn': 'Khách vãng lai',
    'sales.pos.bookings.minutesShort': 'phút',
    'sales.pos.bookings.tabs.pending': 'Mới đặt',
    'sales.pos.bookings.tabs.confirmed': 'Xác nhận',
    'sales.pos.bookings.tabs.cancelled': 'Đã hủy',
    'sales.pos.bookings.status.pending': 'Chờ xác nhận',
    'sales.pos.bookings.status.confirmed': 'Đã đặt',
    'sales.pos.bookings.status.seated': 'Đã nhận bàn',
    'sales.pos.bookings.status.cancelled': 'Đã hủy',
    'sales.pos.bookings.status.overdue': 'Quá giờ',
    'sales.pos.bookings.source.call': 'Điện thoại',
    'sales.pos.bookings.source.store': 'Tại cửa hàng',
    'sales.pos.bookings.source.app': 'Ứng dụng',
    'sales.pos.bookings.deposit.cash': 'Tiền mặt',
    'sales.pos.bookings.deposit.bankTransfer': 'Chuyển khoản',
    'sales.pos.bookings.sections.schedule': 'Lịch nhận bàn',
    'sales.pos.bookings.sections.customer': 'Thông tin khách hàng',
    'sales.pos.bookings.sections.deposit': 'Đặt cọc và ghi chú',
    'sales.pos.bookings.sections.tables': 'Chọn khu vực và bàn',
    'sales.pos.bookings.sections.preorder': 'Đặt trước món',
    'sales.pos.bookings.steps.details': 'Thông tin và bàn',
    'sales.pos.bookings.steps.preorder': 'Chọn món',
    'sales.pos.bookings.steps.continue': 'Tiếp tục',
    'sales.pos.bookings.steps.back': 'Quay lại',
    'sales.pos.bookings.steps.finish': 'Hoàn thành',
    'sales.pos.bookings.fields.arrivalDate': 'Ngày nhận bàn',
    'sales.pos.bookings.fields.arrivalTime': 'Giờ nhận bàn',
    'sales.pos.bookings.fields.guestCount': 'Số lượng khách',
    'sales.pos.bookings.fields.duration': 'Thời lượng giữ bàn',
    'sales.pos.bookings.fields.status': 'Trạng thái',
    'sales.pos.bookings.fields.source': 'Nguồn đặt bàn',
    'sales.pos.bookings.fields.customerName': 'Tên khách hàng',
    'sales.pos.bookings.fields.customerPhone': 'Số điện thoại',
    'sales.pos.bookings.fields.depositAmount': 'Tiền đặt cọc',
    'sales.pos.bookings.fields.depositMethod': 'Hình thức cọc',
    'sales.pos.bookings.fields.note': 'Ghi chú yêu cầu đặc biệt',
    'sales.pos.bookings.tables.multiHint': 'Mỗi lượt đặt chỉ được chọn một bàn.',
    'sales.pos.bookings.tables.capacityWarning':
      'Đã chọn {seats} chỗ cho {guests} khách. Hãy cân nhắc ghép thêm bàn.',
    'sales.pos.bookings.tables.seats': 'chỗ',
    'sales.pos.bookings.tables.selected': 'bàn đã chọn',
    'sales.pos.bookings.tables.filteredHint': 'Đang lọc danh sách đặt bàn theo bàn này',
    'sales.pos.bookings.preorder.hint': 'Món sẽ được chuyển vào order bếp/bar khi khách nhận bàn.',
    'sales.pos.bookings.preorder.items': 'món',
    'sales.pos.bookings.preorder.selectTableFirst': 'Chọn ít nhất một bàn để tải thực đơn phù hợp.',
    'sales.pos.bookings.preorder.search': 'Tìm món ăn, đồ uống',
    'sales.pos.bookings.preorder.note': 'Ghi chú món',
    'sales.pos.bookings.preorder.productList': 'Danh sách sản phẩm',
    'sales.pos.bookings.preorder.selectedProducts': 'Sản phẩm đã đặt',
    'sales.pos.bookings.preorder.emptySelected': 'Chưa có sản phẩm nào được chọn.',
    'sales.pos.bookings.checkIn': 'Nhận bàn',
    'sales.pos.bookings.noShow': 'Khách không đến',
    'sales.pos.bookings.cancel.title': 'Hủy đặt bàn',
    'sales.pos.bookings.cancel.noShowTitle': 'Xác nhận khách không đến',
    'sales.pos.bookings.cancel.reason': 'Lý do hủy',
    'sales.pos.bookings.cancel.confirmAction': 'Hủy',
    'sales.pos.bookings.cancel.noShowReason': 'Khách không đến và không liên lạc được',
    'sales.pos.bookings.cancel.depositAction': 'Xử lý tiền cọc',
    'sales.pos.bookings.cancel.refundDeposit': 'Hoàn tiền cọc',
    'sales.pos.bookings.cancel.retainDeposit': 'Giữ lại tiền cọc',
    'sales.pos.bookings.cancel.refundMethod': 'Phương thức hoàn cọc',
    'sales.order.cancel.depositAction': 'Xử lý tiền cọc',
    'sales.order.cancel.refundDeposit': 'Hoàn tiền cọc',
    'sales.order.cancel.retainDeposit': 'Giữ lại tiền cọc',
    'sales.order.cancel.refundMethod': 'Phương thức hoàn cọc',
    'sales.pos.bookings.errors.requiredFields':
      'Vui lòng nhập đủ thời gian nhận bàn và chọn ít nhất một bàn.',
    'sales.pos.bookings.errors.depositMethodRequired':
      'Vui lòng chọn hình thức cọc khi có tiền đặt cọc.',
    'sales.pos.bookings.errors.tableUnavailable':
      'Một bàn đã chọn vừa phát sinh lịch trùng. Vui lòng bỏ bàn đó hoặc đổi thời gian.',
    'sales.pos.booking.players.clearSelection': 'Bỏ chọn món chung',
    'sales.area.fields.defaultPriceList': 'Bảng giá mặc định',
    'sales.tableSession.errors.saveFailed': 'Không thể cập nhật phiên bàn. Vui lòng thử lại.',
    'sales.tableSession.errors.cancelFailed': 'Hủy bán hàng theo bàn thất bại.',
    'sales.pos.layout.grid': 'Grid',
    'sales.pos.layout.free': 'Tự do',
    'sales.pos.areas.all': 'Tất cả',
    'sales.pos.bookings.upcomingWarningTitle': 'Bàn sắp đến giờ đặt!',
    'sales.pos.bookings.upcomingWarningMessage':
      'Bàn {table} có lịch đặt bàn lúc {time} bởi {customer} ({phone}) - {guests} khách (còn {minutes} phút).',
    'sales.pos.bookings.upcomingWarningConfirm': 'Đã sắp đến giờ bàn đặt bạn vẫn muốn mở bàn chứ!',
    'sales.pos.bookings.upcomingWarningContinue': 'Vẫn mở bàn',
    'sales.pos.bookings.upcomingBadge': 'Sắp có cọc lúc {time}',
    'sales.pos.status.available': 'Trống',
    'sales.pos.status.playing': 'Đang chơi',
    'sales.pos.status.reserved': 'Đặt trước',
    'sales.pos.status.cleaning': 'Đang dọn',
    'sales.pos.meta.notStarted': 'Chưa bắt đầu',
    'sales.pos.billHistory.title': 'Lịch sử bill của tôi',
    'sales.pos.billHistory.shortTitle': 'Bill của tôi',
    'sales.pos.billHistory.close': 'Đóng lịch sử bill',
    'sales.pos.billHistory.search': 'Tìm',
    'sales.pos.billHistory.source': 'Nguồn bán',
    'sales.pos.billHistory.actions': 'Thao tác',
    'sales.pos.billHistory.tableSale': 'Bán hàng theo bàn',
    'sales.invoice.groups.table': 'Bàn',
    'sales.invoice.groups.invoiceCount': '{count} hóa đơn người chơi',
    'sales.invoice.fields.customer': 'Khách hàng',
    'sales.pos.billHistory.directSale': 'Bán hàng thường',
    'sales.pos.billHistory.reprint': 'In lại',
    'sales.pos.billHistory.empty': 'Không có bill nào trong khoảng thời gian đã chọn.',
    'sales.pos.billHistory.printTitle': 'HÓA ĐƠN THANH TOÁN',
    'sales.pos.stats.available': 'Bàn trống',
    'sales.pos.stats.playing': 'Đang chơi',
    'sales.pos.stats.reserved': 'Đặt trước',
    'sales.pos.actions.changeTable': 'Đổi bàn',
    'sales.pos.actions.mergeTable': 'Gộp bàn',
    'sales.pos.actions.payment': 'Thanh toán',
    'sales.pos.actions.reserve': 'Đặt bàn',
    'sales.pos.actions.cancelTable': 'Hủy bàn',
    'sales.pos.actions.cancelSessionConfirm': 'Hủy',
    'sales.pos.cancelTable.title': 'Xác nhận hủy bàn',
    'sales.pos.cancelTable.confirm':
      'Bạn có chắc muốn hủy {table}? Hệ thống sẽ tạo một hóa đơn hủy để ghi nhận thao tác này.',
    'sales.pos.cancelTable.reason': 'Lý do hủy bàn',
    'sales.pos.cancelTable.reasonRequired': 'Lý do hủy bàn phải có ít nhất 3 ký tự.',
    'sales.pos.unsavedChanges.title': 'Thay đổi chưa được lưu',
    'sales.pos.unsavedChanges.message':
      '{table} đang có thay đổi chưa lưu. Bạn có muốn lưu trước khi tiếp tục không?',
    'sales.pos.unsavedChanges.discard': 'Không lưu',
    'sales.pos.startTime.action': 'Chỉnh giờ vào bàn',
    'sales.pos.startTime.title': 'Chỉnh giờ vào bàn',
    'sales.pos.startTime.field': 'Giờ vào bàn',
    'sales.pos.startTime.timeField': 'Thời gian vào bàn',
    'sales.pos.startTime.reason': 'Lý do điều chỉnh',
    'sales.pos.startTime.reasonHint': 'Bắt buộc, tối thiểu 5 ký tự.',
    'sales.pos.startTime.reasonRequired': 'Lý do phải có ít nhất 5 ký tự.',
    'sales.pos.startTime.pastOnly': 'Chỉ được chọn thời điểm hiện tại hoặc trong quá khứ.',
    'sales.pos.startTime.future': 'Giờ vào bàn không được ở tương lai.',
    'sales.pos.startTime.invalid': 'Giờ vào bàn không hợp lệ.',
    'sales.pos.startTime.afterPlayerJoined':
      'Giờ vào bàn không được sau thời điểm người chơi tham gia.',
    'sales.pos.startTime.unavailable': 'Không thể điều chỉnh giờ vào bàn ở chế độ hiện tại.',
    'sales.pos.startTime.draftHint': 'Giờ này sẽ được dùng khi lưu/mở bàn.',
    'sales.pos.tableRate.action': 'Chỉnh đơn giá bàn',
    'sales.pos.tableRate.title': 'Chỉnh đơn giá bàn',
    'sales.pos.tableRate.field': 'Đơn giá tiền bàn',
    'sales.pos.tableRate.invalid': 'Đơn giá tiền bàn không hợp lệ.',
    'sales.pos.tableRate.defaultRate': 'Đơn giá hiện tại theo khu vực: {rate}.',
    'sales.pos.booking.title': 'Đặt bàn',
    'sales.pos.booking.conflict.title': 'Đơn hàng đã thay đổi',
    'sales.pos.booking.conflict.message':
      'Đơn hàng đã được thay đổi ở nơi khác. Tải lại phiên bản mới nhất?',
    'sales.pos.booking.duration': 'Thời gian chơi',
    'sales.pos.duration.minutes': '{minutes} phút',
    'sales.pos.duration.hours': '{hours} giờ',
    'sales.pos.duration.hourMinutes': '{hours} giờ {minutes} phút',
    'sales.pos.duration.dayHoursMinutes': '{days} ngày {hours} giờ {minutes} phút',
    'sales.pos.booking.openSession': 'Mở phiên',
    'sales.pos.booking.areaLabel': 'Khu vực',
    'sales.pos.booking.areaFallback': 'Khu vực POOL',
    'sales.pos.booking.tabs.addItem': 'Thêm món',
    'sales.pos.booking.tabs.players': 'Người chơi ({count})',
    'sales.pos.booking.staff': 'Người xử lý',
    'sales.pos.booking.counterStaff': 'Nhân viên trực quầy',
    'sales.pos.booking.salesChannel': 'Kênh bán hàng',
    'sales.pos.booking.directSales': 'Bán trực tiếp',
    'sales.pos.booking.search': 'Tìm kiếm',
    'sales.pos.booking.defaultPriceList': 'Bảng giá chung',
    'sales.pos.booking.stock': 'SL',
    'sales.pos.booking.stockRemaining': 'còn {count}',
    'sales.pos.booking.orderedQuantity': 'Đã đặt {count}',
    'sales.pos.booking.productOutOfStock': 'Sản phẩm hết hàng',
    'sales.pos.booking.line.pendingKitchen': 'Chờ bếp: {count}',
    'sales.pos.booking.searchPlaceholderShort': 'Tìm món...',
    'sales.pos.booking.invoiceInfo': 'Thông tin hóa đơn',
    'sales.pos.booking.emptyOrder': 'Chưa có món nào',
    'sales.pos.booking.close': 'Đóng (ESC)',
    'sales.pos.booking.update': 'Cập Nhật (F1)',
    'sales.pos.booking.enterTable': 'Vào bàn (F1)',
    'sales.pos.booking.paymentMethod': 'Phương thức',
    'sales.pos.booking.paymentMethods.cash': 'Tiền mặt',
    'sales.pos.booking.paymentMethods.card': 'Thẻ',
    'sales.pos.booking.paymentMethods.transfer': 'Chuyển khoản',
    'sales.pos.booking.discount': 'Giảm giá',
    'sales.pos.booking.tableDiscount': 'Giảm giá tiền bàn',
    'sales.pos.booking.summary.productTotal': 'Tổng tiền sản phẩm',
    'sales.pos.booking.summary.tableTotal': 'Tổng tiền bàn',
    'sales.pos.booking.summary.discount': 'Giảm giá',
    'sales.pos.booking.summary.tableDiscount': 'Giảm giá tiền bàn',
    'sales.pos.booking.summary.finalTotal': 'Thành tiền',
    'sales.pos.booking.summary.billTitle': 'Tổng kết hóa đơn',
    'sales.pos.booking.summary.invoiceTotal': 'Tổng hóa đơn',
    'sales.pos.booking.summary.tableTimeAmount': 'Tiền giờ bàn',
    'sales.pos.booking.summary.tableTimeShared': 'Tiền giờ bàn (chia {count})',
    'sales.pos.booking.summary.serviceAmount': 'Dịch vụ (Đồ ăn / uống)',
    'sales.pos.booking.summary.sharedService': 'Dùng chung (chia {count})',
    'sales.pos.booking.summary.paymentTotal': 'Tổng thanh toán',
    'sales.pos.booking.summary.bookingDeposit': 'Tiền đặt cọc còn lại',
    'sales.pos.booking.summary.representative': 'Người đại diện đặt bàn',
    'sales.pos.booking.summary.amountDue': 'Cần thanh toán',
    'sales.pos.booking.summary.playerPayment': 'Thanh toán theo người',
    'sales.pos.booking.summary.playerEstimates': 'Tạm tính theo người',
    'sales.pos.booking.summary.playerTotal': 'Tổng',
    'sales.pos.booking.summary.payPlayer': 'Thanh toán',
    'sales.pos.booking.ownOrder.title': 'Chọn sản phẩm',
    'sales.pos.booking.ownOrder.confirm': 'Xác nhận ({count} sản phẩm)',
    'sales.pos.booking.changeTable.target': 'Chọn bàn chuyển đến',
    'sales.pos.booking.changeTable.empty': 'Không có bàn trống để chuyển',
    'sales.pos.booking.changeTable.seats': 'ghế',
    'sales.pos.booking.changeTable.current': 'Bàn hiện tại',
    'sales.pos.booking.changeTable.new': 'Bàn mới',
    'sales.pos.booking.changeTable.notSelected': 'Chưa chọn',
    'sales.pos.booking.changeTable.save': 'Lưu',
    'sales.pos.booking.changeTable.availableTitle': 'Chuyển sang bàn trống',
    'sales.pos.booking.changeTable.availableHint':
      'Phiên hiện tại sẽ kết thúc và tiếp tục ở bàn mới.',
    'sales.pos.booking.changeTable.errors.occupied': 'Bàn đích đã có phiên đang chơi.',
    'sales.pos.booking.changeTable.errors.notPlaying': 'Bàn đích không còn phiên đang chơi để gộp.',
    'sales.pos.booking.changeTable.errors.versionConflict':
      'Dữ liệu bàn đã thay đổi. Hãy tải lại rồi thử lại.',
    'sales.pos.booking.changeTable.errors.sourceClosed':
      'Phiên bàn hiện tại đã kết thúc hoặc không còn tồn tại.',
    'sales.pos.booking.changeTable.errors.sameTable': 'Bàn đích phải khác bàn hiện tại.',
    'sales.pos.booking.changeTable.errors.unsupported':
      'Chức năng đổi bàn chưa khả dụng trong chế độ hiện tại.',
    'sales.pos.booking.changeTable.errors.settlementLocked':
      'Không thể đổi/gộp bàn sau khi đã thanh toán một phần.',
    'sales.pos.booking.changeTable.errors.cooldown':
      'Bàn vừa được đổi hoặc gộp. Vui lòng chờ thêm {seconds} giây.',
    'sales.pos.booking.changeTable.errors.cooldownGeneric':
      'Mỗi phiên bàn chỉ được đổi hoặc gộp một lần trong 60 giây.',
    'sales.pos.booking.changeTable.cooldownShort': 'Chờ {seconds}s',
    'sales.pos.booking.changeTable.errors.saveFirst':
      'Không thể lưu order hiện tại trước khi đổi bàn.',
    'sales.pos.booking.mergeTable.from': 'Gộp từ bàn',
    'sales.pos.booking.mergeTable.to': 'vào bàn',
    'sales.pos.booking.mergeTable.notSelected': 'Chưa chọn',
    'sales.pos.booking.mergeTable.empty': 'Không có bàn đang chơi để gộp',
    'sales.pos.booking.mergeTable.title': 'Gộp vào bàn đang chơi',
    'sales.pos.booking.mergeTable.hint':
      'Tiền bàn và món sẽ được giữ theo từng phiên và người chơi.',
    'sales.pos.booking.mergeTable.reverse': 'Đảo chiều',
    'sales.pos.booking.mergeTable.confirm': 'Xác nhận',
    'sales.pos.booking.payAndPrint': 'TT & In (F2)',
    'sales.pos.booking.quickPay': 'TT Nhanh (F3)',
    'sales.pos.booking.payOnly': 'Chỉ TT (F4)',
    'sales.pos.booking.notePlaceholder': 'Thêm ghi chú...',
    'sales.pos.booking.noteTitle': 'Ghi chú: {name}',
    'sales.pos.booking.editUnitPrice': 'Sửa đơn giá',
    'sales.pos.booking.playerOne': 'Người số 1',
    'sales.pos.booking.invoiceTotal': 'Tổng cộng',
    'sales.pos.booking.detailTitle': 'Chi tiết bàn',
    'sales.pos.booking.searchPlaceholder': 'Tìm món ăn, đồ uống...',
    'sales.pos.booking.orderedItems': 'Món đã gọi',
    'sales.pos.booking.orderedItemsHint': 'Bấm vào món để chỉnh giá, giảm giá, ghi chú',
    'sales.pos.booking.line.reset': 'reset',
    'sales.pos.booking.line.discountAmount': 'Số tiền',
    'sales.pos.booking.line.discountPercent': 'Phần trăm',
    'sales.pos.booking.line.afterDiscount': 'Giá sau giảm',
    'sales.pos.booking.line.notePlaceholder': 'Thêm ghi chú cho món...',
    'sales.pos.booking.line.remove': 'Xóa món này',
    'sales.pos.booking.order.details': 'Thông tin đơn hàng',
    'sales.pos.booking.order.note': 'Ghi chú đơn hàng',
    'sales.pos.booking.order.notePlaceholder': 'Thêm ghi chú cho toàn bộ đơn hàng...',
    'sales.pos.booking.order.discountType': 'Loại giảm giá',
    'sales.pos.booking.order.discountValue': 'Giá trị giảm',
    'sales.pos.booking.order.tableDiscount': 'Giảm tiền bàn',
    'sales.pos.booking.voucherCode': 'Mã giảm giá',
    'sales.pos.booking.voucherCodePlaceholder': 'Nhập mã giảm giá...',
    'sales.pos.booking.selectVoucher': 'Chọn mã giảm giá',
    'sales.pos.booking.selectVoucherPlaceholder': 'Chọn mã giảm giá...',
    'sales.pos.booking.voucherAppliedPercent': '{code} ({percent}% - {amount})',
    'sales.pos.booking.voucherAppliedFixed': '{code} ({value} - {amount})',
    'sales.pos.booking.voucherAppliedFixedExact': '{code} ({amount})',
    'sales.pos.booking.voucherAppliedSimple': '{code}',
    'sales.pos.booking.order.discountTypes.percent': 'Phần trăm',
    'sales.pos.booking.order.discountTypes.amount': 'Số tiền cố định',
    'sales.pos.booking.order.estimatedDiscount': 'Tạm tính giảm: {amount}',
    'sales.pos.booking.order.saveFailed': 'Không thể lưu đơn hàng. Vui lòng thử lại.',
    'sales.pos.booking.order.fixedDiscountMax': 'Mức giảm tối đa là {amount}.',
    'sales.pos.booking.order.playerRequired': 'Đơn hàng phải có ít nhất một người chơi.',
    'sales.pos.booking.sharedItems': 'Dùng chung',
    'sales.pos.booking.hourlyRate': 'Đơn giá / giờ',
    'sales.pos.booking.actions.saveAndPrintPreview': 'Lưu & tạm tính',
    'sales.pos.booking.actions.printPreview': 'In tạm tính',
    'sales.pos.booking.actions.printBill': 'In',
    'sales.pos.booking.actions.printPlayerBill': 'In',
    'sales.pos.booking.print.tableBillTitle': 'HÓA ĐƠN TẠM TÍNH',
    'sales.pos.booking.print.playerBillTitle': 'HÓA ĐƠN THEO NGƯỜI',
    'sales.pos.booking.print.paidBillTitle': 'HÓA ĐƠN',
    'sales.pos.booking.print.tableTime': 'Tiền giờ bàn',
    'sales.pos.booking.print.tableTimePrevious': 'Tiền bàn trước khi đổi/gộp',
    'sales.pos.booking.print.tableTimeCurrent': 'Tiền bàn hiện tại',
    'sales.pos.booking.print.sharedItems': 'Sản phẩm dùng chung',
    'sales.pos.booking.print.personalItems': 'Sản phẩm riêng',
    'sales.pos.booking.actions.changeOrMerge': 'Đổi/Ghép bàn',
    'sales.pos.booking.actions.payAll': 'Thanh toán',
    'sales.pos.booking.actions.paySelected': 'Thanh toán người đã chọn',
    'sales.pos.booking.actions.selectAllPayers': 'Chọn tất cả người chơi',
    'sales.pos.booking.summary.selectedTotal': 'Tổng người đã chọn',
    'sales.pos.booking.checkout.success': 'Thanh toán thành công.',
    'sales.pos.booking.checkout.failed': 'Không thể thanh toán. Vui lòng thử lại.',
    'sales.pos.booking.checkout.selectionRequired': 'Vui lòng chọn ít nhất một người chơi.',
    'sales.pos.booking.checkout.unitMissing': 'Sản phẩm thiếu đơn vị tính, không thể thanh toán.',
    'sales.pos.booking.checkout.sessionMissing': 'Bàn chưa có phiên đang chơi.',
    'sales.pos.booking.players.defaultName': 'Người chơi {number}',
    'sales.pos.booking.players.title': 'Người chơi',
    'sales.pos.booking.players.total': 'Người chơi ({count})',
    'sales.pos.booking.players.selectAll': 'Chọn tất cả',
    'sales.pos.booking.players.add': 'Thêm người',
    'sales.pos.booking.players.limitReached': 'Bàn chỉ được phép có tối đa {count} người chơi',
    'sales.pos.booking.players.removeLocked':
      'Không thể xóa người chơi có liên quan đến món đã thanh toán',
    'sales.pos.booking.players.customer': 'Thành viên',
    'sales.pos.booking.players.walkInCustomer': 'Khách',
    'sales.pos.booking.players.name': 'Tên người chơi',
    'sales.pos.booking.players.unnamed': 'Chưa đặt tên',
    'sales.pos.booking.players.phone': 'Số điện thoại',
    'sales.pos.booking.players.phoneOptional': 'Số điện thoại (tùy chọn)',
    'sales.pos.booking.players.phoneDuplicate':
      'Số điện thoại đã được sử dụng cho người chơi khác.',
    'sales.pos.booking.players.remove': 'Xóa người chơi này',
    'sales.pos.booking.players.removeConfirm': 'Bạn có chắc chắn muốn xóa người chơi này khỏi bàn?',
    'sales.pos.booking.players.note': 'Ghi chú người chơi',
    'sales.pos.booking.players.startedAt': 'Vào lúc',
    'sales.pos.booking.players.hours': 'giờ',
    'sales.pos.booking.players.minutes': 'phút',
    'sales.pos.booking.players.estimatedAmount': 'Số tiền tạm tính',
    'sales.pos.booking.players.points': 'ĐIỂM',
    'sales.pos.booking.players.ownOrder': 'Gọi món riêng',
    'sales.pos.booking.players.sharedOrder': 'Dùng chung',
    'sales.pos.booking.players.sharedSelection': 'Chọn món chung',
    'sales.pos.booking.players.scrollPrevious': 'Xem người chơi phía trước',
    'sales.pos.booking.players.scrollNext': 'Xem người chơi phía sau',
    'sales.pos.booking.players.sharedAll': 'Dùng chung cho tất cả ({count} người)',
    'sales.pos.booking.players.joinedAt': 'Vào lúc {time}',
    'sales.pos.booking.players.leftAt': 'Về lúc {time}',
    'sales.pos.booking.players.markLeft': 'Đánh dấu đã về',
    'sales.pos.booking.players.reopen': 'Mở lại (chơi tiếp)',
    'sales.pos.booking.players.settled': 'Đã thanh toán',
    'sales.pos.booking.categories.all': 'Tất cả',
    'sales.pos.booking.categories.ingredients': 'NGUYÊN LIỆU ĐẶT HÀNG',
    'sales.pos.booking.categories.mixedDrinks': 'ĐỒ UỐNG CHẾ BIẾN',
    'sales.pos.booking.categories.accessories': 'PHỤ KIỆN',
    'sales.pos.booking.categories.mixedFood': 'ĐỒ ĂN CHẾ BIẾN',
    'sales.pos.booking.categories.tableTime': 'TIỀN BÀN',
    'sales.pos.booking.categories.tobacco': 'THUỐC LÁ',
    'sales.pos.booking.categories.fastFood': 'ĐỒ ĂN NHANH',
    'sales.pos.booking.categories.quickDrinks': 'ĐỒ UỐNG NHANH',
    'sales.pos.booking.products.caromTable': 'Bàn CAROM 3C',
    'sales.pos.booking.products.water': 'Nước suối',
    'sales.pos.booking.products.soyMilk': 'Sữa đậu nành Tribeco Trisoy',
    'sales.pos.booking.products.squashTea': 'Bí đao',
    'sales.pos.booking.products.c2': 'C2',
    'sales.pos.booking.products.zeroAlcohol': 'Không Độ',
    'sales.pos.booking.products.nuti': 'Nuti',
    'sales.pos.booking.products.coca': 'Coca',
    'sales.pos.booking.products.fries': 'Khoai tây chiên',
    'sales.pos.booking.products.driedSquid': 'Khô mực',
    'sales.pos.booking.products.fishBallGarlic': 'Cá viên mắm tỏi',
    'sales.pos.booking.products.mixedFishBall': 'Cá viên lộn xộn',
    'sales.pos.booking.products.fishNoodles': 'Mì cá viên',
    'sales.pos.booking.products.beefNoodles': 'Mì bò 2 vắt',
    'sales.pos.booking.products.eggNoodles': 'Mì trứng 2 vắt',
    'sales.tablePricing.actions.preview': 'Xem trước',
    'sales.tablePricing.errors.previewFailed': 'Không thể xem trước giá bàn. Vui lòng thử lại.',
    'sales.tablePricing.preview.title': 'Xem trước giá bàn',
    'sales.tablePricing.preview.table': 'Bàn',
    'sales.tablePricing.preview.source': 'Nguồn giá',
    'sales.tablePricing.preview.totalMinutes': 'Tổng phút',
    'sales.tablePricing.preview.totalAmount': 'Tổng tiền',
    'sales.areaPricing.model': 'chính sách giá khu vực',
    'sales.areaPricing.ruleModel': 'khung giá',
    'sales.areaPricing.actions.add': 'Thêm chính sách giá',
    'sales.areaPricing.actions.create': 'Thêm chính sách giá',
    'sales.areaPricing.actions.update': 'Cập nhật chính sách giá',
    'sales.areaPricing.actions.deleteTitle': 'Xóa chính sách giá',
    'sales.areaPricing.actions.addRule': 'Thêm khung giá',
    'sales.areaPricing.actions.createRule': 'Tạo khung giá',
    'sales.areaPricing.actions.updateRule': 'Cập nhật khung giá',
    'sales.areaPricing.actions.preview': 'Xem trước',
    'sales.areaPricing.fields.code': 'Mã chính sách',
    'sales.areaPricing.fields.name': 'Tên chính sách',
    'sales.areaPricing.fields.description': 'Mô tả',
    'sales.areaPricing.fields.rulesCount': 'Số khung',
    'sales.areaPricing.fields.default': 'Mặc định',
    'sales.areaPricing.fields.defaultLocked': 'Cần chọn chính sách khác làm mặc định trước khi gỡ.',
    'sales.areaPricing.defaultTypes.default': 'Chính sách mặc định',
    'sales.areaPricing.defaultTypes.standard': 'Chính sách thường',
    'sales.areaPricing.fields.status': 'Trạng thái',
    'sales.areaPricing.fields.ruleName': 'Tên khung giá',
    'sales.areaPricing.fields.timeRange': 'Khung giờ',
    'sales.areaPricing.fields.priceAmount': 'Giá',
    'sales.areaPricing.fields.priceUnit': 'Đơn vị giá',
    'sales.areaPricing.fields.pricePerMinute': 'Giá/phút',
    'sales.areaPricing.fields.pricePerHour': 'Giá/giờ',
    'sales.areaPricing.fields.priority': 'Ưu tiên',
    'sales.areaPricing.fields.roundingPrecision': 'Làm tròn',
    'sales.areaPricing.fields.startTime': 'Giờ bắt đầu',
    'sales.areaPricing.fields.endTime': 'Giờ kết thúc',
    'sales.areaPricing.fields.daysOfWeek': 'Ngày áp dụng',
    'sales.areaPricing.fields.startAt': 'Bắt đầu',
    'sales.areaPricing.fields.endAt': 'Kết thúc',
    'sales.areaPricing.priceUnits.minute': '/phút',
    'sales.areaPricing.priceUnits.hour': '/giờ',
    'sales.areaPricing.preview.title': 'Xem trước giá khu vực',
    'sales.areaPricing.preview.table': 'Bàn',
    'sales.areaPricing.preview.totalMinutes': 'Tổng phút',
    'sales.areaPricing.preview.totalAmount': 'Tổng tiền',
    'sales.areaPricing.messages.deleteConfirm': 'Bạn có chắc muốn xóa chính sách giá này?',
    'sales.areaPricing.messages.deleteRuleConfirm': 'Bạn có chắc muốn xóa khung giá này?',
    'sales.areaPricing.errors.saveFailed': 'Không thể lưu giá khu vực. Vui lòng thử lại.',
    'sales.areaPricing.errors.endTimeAfterStart': 'Giờ kết thúc phải lớn hơn giờ bắt đầu.',
    'sales.area.model': 'Khu vực',
    'sales.area.title': 'Quản lý khu vực',
    'sales.area.fields.branch': 'Chi nhánh',
    'sales.area.fields.code': 'Mã khu vực',
    'sales.area.placeholders.codeAuto': 'Để trống sẽ tự sinh mã',
    'sales.area.fields.name': 'Tên khu vực',
    'sales.area.fields.icon': 'Biểu tượng',
    'sales.area.fields.areaPricingPolicy': 'Chính sách giá khu vực',
    'sales.area.fields.status': 'Trạng thái',
    'sales.area.fields.sortOrder': 'Sắp xếp',
    'sales.area.actions.add': 'Thêm khu vực',
    'sales.area.actions.create': 'Thêm khu vực',
    'sales.area.actions.update': 'Cập nhật khu vực',
    'sales.area.dialog.createSubtitle': 'Thêm thông tin khu vực vào hệ thống',
    'sales.area.dialog.updateSubtitle': 'Cập nhật thông tin khu vực trong hệ thống',
    'sales.area.actions.submitCreate': 'Lưu',
    'sales.area.actions.submitUpdate': 'Lưu',
    'sales.area.actions.cancel': 'Đóng',
    'sales.area.actions.deleteTitle': 'Xóa khu vực',
    'sales.area.actions.import': 'Nhập Excel',
    'sales.area.actions.export': 'Xuất Excel',
    'sales.area.deleteConfirm': 'Bạn có chắc muốn xóa khu vực {name}?',
    'sales.area.errors.saveFailed': 'Không thể lưu khu vực. Vui lòng thử lại.',
    'sales.area.export.error': 'Không thể export danh sách khu vực.',
    'sales.area.import.title': 'Import danh sách khu vực',
    'sales.area.import.subtitle': 'Tải file mẫu, nhập dữ liệu và kiểm tra trước khi lưu.',
    'sales.area.import.loadingCatalog': 'Đang tải danh mục dùng để kiểm tra dữ liệu...',
    'sales.area.import.retry': 'Thử lại',
    'sales.area.import.templateTitle': 'Tải file mẫu',
    'sales.area.import.templateDescription': 'File mẫu có hướng dẫn và danh mục mã hợp lệ.',
    'sales.area.import.downloadTemplate': 'Tải file mẫu Excel',
    'sales.area.import.requiredLegend': 'Trường bắt buộc.',
    'sales.area.import.notes.codes': 'Mã khu vực có thể để trống để hệ thống tự sinh.',
    'sales.area.import.notes.catalogs':
      'Dùng đúng mã chi nhánh, bảng giá và chính sách trong sheet Danh mục.',
    'sales.area.import.notes.values':
      'Trạng thái nhận active/inactive hoặc true/false; thứ tự là số nguyên không âm.',
    'sales.area.import.fileTitle': 'Chọn file dữ liệu',
    'sales.area.import.fileDescription': 'Hệ thống sẽ kiểm tra từng dòng trước khi import.',
    'sales.area.import.chooseFile': 'Chọn file Excel',
    'sales.area.import.supportedFormats': 'Hỗ trợ .xlsx, .xls; tối đa 5 MB.',
    'sales.area.import.errors.invalidFileType': 'Chỉ hỗ trợ file Excel .xlsx hoặc .xls.',
    'sales.area.import.errors.fileTooLarge': 'File vượt quá dung lượng tối đa 5 MB.',
    'sales.area.import.errors.noRows': 'File không có dòng dữ liệu khu vực.',
    'sales.area.import.errors.cannotRead': 'Không thể đọc file. Hãy dùng đúng file mẫu và thử lại.',
    'sales.area.import.errors.catalogLoadFailed': 'Không thể tải danh mục import khu vực.',
    'sales.area.import.errors.templateDownloadFailed': 'Không thể tải file mẫu khu vực.',
    'sales.area.import.errors.rowFailed': 'Không thể tạo khu vực ở dòng này.',
    'sales.area.import.summary.total': 'Tổng: {count}',
    'sales.area.import.summary.valid': 'Hợp lệ: {count}',
    'sales.area.import.summary.invalid': 'Có lỗi: {count}',
    'sales.area.import.errorListTitle': 'Các dòng cần kiểm tra',
    'sales.area.import.rowLabel': 'Dòng {row}',
    'sales.area.import.result': 'Đã import {success} khu vực; {failed} dòng không thành công.',
    'sales.area.import.process': 'Import {count} khu vực',

    'sales.table.model': 'Bàn',
    'sales.table.title': 'Quản lý bàn',
    'sales.table.fields.branch': 'Chi nhánh',
    'sales.table.fields.area': 'Khu vực',
    'sales.table.fields.code': 'Mã bàn',
    'sales.table.fields.linkCode': 'Mã liên kết',
    'sales.table.placeholders.codeAuto': 'Để trống sẽ tự sinh mã',
    'sales.table.placeholders.linkCode': 'Dùng cho QR / Webview order',
    'sales.table.fields.name': 'Tên bàn',
    'sales.table.fields.pricing': 'Giá khu vực',
    'sales.table.fields.useAreaPricing': 'Dùng giá theo khu vực',
    'sales.table.options.useAreaPricingYes': 'Có',
    'sales.table.options.useAreaPricingNo': 'Không',
    'sales.table.fields.areaPricingPolicyOverride': 'Chính sách giá riêng',
    'sales.table.fields.seats': 'Số chỗ ngồi',
    'sales.table.fields.seatsShort': 'chỗ',
    'sales.table.errors.seatsMax': 'Số chỗ ngồi không được lớn hơn {max}',
    'sales.table.errors.sortOrderMax': 'Thứ tự sắp xếp không được lớn hơn {max}',
    'sales.table.fields.status': 'Trạng thái',
    'sales.table.fields.sortOrder': 'Sắp xếp',
    'sales.table.pricing.inherited': 'Kế thừa khu vực',
    'sales.table.pricing.overrideMissing': 'Chưa chọn giá riêng',
    'sales.table.actions.add': 'Thêm bàn',
    'sales.table.actions.create': 'Thêm bàn',
    'sales.table.actions.update': 'Cập nhật bàn',
    'sales.table.actions.submitCreate': 'Tạo bàn',
    'sales.table.actions.submitUpdate': 'Lưu thay đổi',
    'sales.table.actions.cancel': 'Đóng',
    'sales.table.actions.deleteTitle': 'Xóa bàn',
    'sales.table.actions.import': 'Nhập Excel',
    'sales.table.actions.export': 'Xuất Excel',
    'sales.table.deleteConfirm': 'Bạn có chắc muốn xóa bàn {name}?',
    'sales.table.errors.saveFailed': 'Không thể lưu bàn. Vui lòng thử lại.',
    'sales.table.export.error': 'Không thể export danh sách bàn.',
    'sales.table.import.title': 'Import danh sách bàn',
    'sales.table.import.subtitle': 'Tải file mẫu, nhập dữ liệu và kiểm tra trước khi lưu.',
    'sales.table.import.loadingCatalog': 'Đang tải danh mục dùng để kiểm tra dữ liệu...',
    'sales.table.import.retry': 'Thử lại',
    'sales.table.import.templateTitle': 'Tải file mẫu',
    'sales.table.import.templateDescription': 'File mẫu có hướng dẫn và danh mục mã hợp lệ.',
    'sales.table.import.downloadTemplate': 'Tải file mẫu Excel',
    'sales.table.import.requiredLegend': 'Trường bắt buộc.',
    'sales.table.import.conditionalLegend': 'Bắt buộc khi không sử dụng giá khu vực.',
    'sales.table.import.notes.codes': 'Mã bàn có thể để trống để hệ thống tự sinh.',
    'sales.table.import.notes.area': 'Mã khu vực phải thuộc đúng chi nhánh trên cùng dòng.',
    'sales.table.import.notes.pricing':
      'Nếu Sử dụng giá khu vực là false, phải nhập mã chính sách giá riêng.',
    'sales.table.import.notes.values':
      'Trạng thái và Sử dụng giá khu vực nhận Có/Không hoặc true/false.',
    'sales.table.import.fileTitle': 'Chọn file dữ liệu',
    'sales.table.import.fileDescription': 'Hệ thống sẽ kiểm tra từng dòng trước khi import.',
    'sales.table.import.chooseFile': 'Chọn file Excel',
    'sales.table.import.supportedFormats': 'Hỗ trợ .xlsx, .xls; tối đa 5 MB.',
    'sales.table.import.errors.invalidFileType': 'Chỉ hỗ trợ file Excel .xlsx hoặc .xls.',
    'sales.table.import.errors.fileTooLarge': 'File vượt quá dung lượng tối đa 5 MB.',
    'sales.table.import.errors.noRows': 'File không có dòng dữ liệu bàn.',
    'sales.table.import.errors.cannotRead':
      'Không thể đọc file. Hãy dùng đúng file mẫu và thử lại.',
    'sales.table.import.errors.catalogLoadFailed': 'Không thể tải danh mục import bàn.',
    'sales.table.import.errors.templateDownloadFailed': 'Không thể tải file mẫu bàn.',
    'sales.table.import.errors.rowFailed': 'Không thể tạo bàn ở dòng này.',
    'sales.table.import.summary.total': 'Tổng: {count}',
    'sales.table.import.summary.valid': 'Hợp lệ: {count}',
    'sales.table.import.summary.invalid': 'Có lỗi: {count}',
    'sales.table.import.errorListTitle': 'Các dòng cần kiểm tra',
    'sales.table.import.rowLabel': 'Dòng {row}',
    'sales.table.import.result': 'Đã import {success} bàn; {failed} dòng không thành công.',
    'sales.table.import.process': 'Import {count} bàn',

    'sales.tablePricing.model': 'Thiết lập giá bàn',
    'sales.tablePricing.title': 'Thiết lập giá bán cho bàn',
    'sales.tablePricing.fields.branch': 'Chi nhánh',
    'sales.tablePricing.fields.area': 'Khu vực',
    'sales.tablePricing.fields.table': 'Bàn',
    'sales.tablePricing.fields.tableOptional': 'Bàn (tùy chọn)',
    'sales.tablePricing.fields.priceList': 'Bảng giá',
    'sales.tablePricing.fields.priority': 'Ưu tiên',
    'sales.tablePricing.fields.status': 'Trạng thái',
    'sales.tablePricing.fields.startAt': 'Bắt đầu áp dụng',
    'sales.tablePricing.fields.endAt': 'Kết thúc áp dụng',
    'sales.tablePricing.actions.add': 'Thêm thiết lập giá',
    'sales.tablePricing.actions.create': 'Tạo thiết lập giá',
    'sales.tablePricing.actions.update': 'Cập nhật thiết lập giá',
    'sales.tablePricing.actions.submitCreate': 'Tạo thiết lập',
    'sales.tablePricing.actions.submitUpdate': 'Lưu thay đổi',
    'sales.tablePricing.actions.cancel': 'Đóng',
    'sales.tablePricing.actions.deleteTitle': 'Xóa thiết lập giá',
    'sales.tablePricing.deleteConfirm': 'Bạn có chắc muốn xóa thiết lập giá bàn này?',
    'sales.tablePricing.errors.saveFailed': 'Không thể lưu thiết lập giá bàn. Vui lòng thử lại.',

    'sales.invoice.title': 'Bán hàng',
    'sales.pricing.automatic': 'Tự động / Bảng giá chung',
    'sales.pricing.unavailable': 'Bảng giá không còn khả dụng',
    'sales.invoice.searchProduct': 'Tìm sản phẩm',
    'sales.invoice.addSale': 'Thêm đơn bán',
    'sales.invoice.tabs.draft': 'Đơn {number}',
    'sales.invoice.sections.products': 'Sản phẩm',
    'sales.invoice.sections.summary': 'Thông tin đơn bán',
    'sales.invoice.sections.totals': 'Thanh toán',
    'sales.invoice.sections.saleType': 'Hình thức bán hàng',
    'sales.invoice.sections.deliveryInfo': 'Thông tin giao hàng',
    'sales.invoice.saleTypes.counter': 'Bán tại quầy',
    'sales.invoice.saleTypes.delivery': 'Bán giao hàng',
    'sales.invoice.fields.deliveryDate': 'Ngày giao hàng',
    'sales.invoice.fields.deliveryPartner': 'Đơn vị vận chuyển',
    'sales.invoice.fields.recipientName': 'Người nhận',
    'sales.invoice.fields.recipientPhone': 'Số điện thoại người nhận',
    'sales.invoice.fields.recipientAddress': 'Địa chỉ giao hàng',
    'sales.invoice.fields.shippingFee': 'Phí vận chuyển',
    'sales.invoice.fields.shippingFeePayer': 'Bên trả phí',
    'sales.invoice.fields.customerShippingAmount': 'Phần phí khách trả',
    'sales.invoice.fields.shopShippingAmount': 'Phần phí cửa hàng trả',
    'sales.invoice.shippingPayer.customer': 'Khách trả',
    'sales.invoice.shippingPayer.shop': 'Cửa hàng trả',
    'sales.invoice.shippingPayer.shared': 'Cùng trả',
    'sales.invoice.emptyLines': 'Chưa có sản phẩm nào.',
    'sales.invoice.fields.seller': 'Người bán',
    'sales.invoice.fields.priceList': 'Bảng giá',
    'sales.invoice.fields.invoiceCode': 'Mã hóa đơn',
    'sales.invoice.fields.saleDate': 'Ngày bán',
    'sales.invoice.fields.saleTime': 'Thời gian bán',
    'sales.invoice.fields.product': 'Sản phẩm',
    'sales.invoice.fields.quantity': 'Số lượng',
    'sales.invoice.fields.unit': 'Đơn vị tính',
    'sales.invoice.fields.unitPrice': 'Giá bán',
    'sales.invoice.fields.discount': 'Giảm giá',
    'sales.invoice.fields.discountAmount': 'Giảm giá',
    'sales.invoice.fields.voucherCode': 'Mã giảm giá',
    'sales.invoice.fields.voucherDiscount': 'Giảm theo mã',
    'sales.invoice.fields.discountTypes.amount': 'Số tiền',
    'sales.invoice.fields.discountTypes.percent': 'Phần trăm',
    'sales.invoice.fields.lineTotal': 'Thành tiền',
    'sales.invoice.fields.subtotal': 'Tổng tiền',
    'sales.invoice.fields.vatRate': 'VAT (%)',
    'sales.invoice.fields.vatWithRate': 'VAT ({rate}%)',
    'sales.invoice.fields.vatAmount': 'Tiền VAT',
    'sales.invoice.fields.customerPayable': 'Cần trả',
    'sales.invoice.fields.totalAmount': 'Thành tiền',
    'sales.invoice.fields.paidAmount': 'Khách thanh toán',
    'sales.invoice.fields.paidTotal': 'Đã trả',
    'sales.invoice.fields.pointPayment': 'Thanh toán bằng điểm ({points} điểm)',
    'sales.invoice.fields.remainingAmount': 'Còn lại',
    'sales.invoice.fields.changeDueAmount': 'Tiền thừa trả khách',
    'sales.invoice.fields.debtAmount': 'Còn nợ',
    'sales.invoice.fields.paymentMethod': 'Phương thức thanh toán',
    'sales.invoice.fields.status': 'Trạng thái',
    'sales.invoice.fields.note': 'Ghi chú',
    'sales.invoice.fields.cancelReason': 'Lý do hủy',
    'sales.invoice.summary.pageTotal': 'Tổng trang này',
    'sales.invoice.summary.invoiceCount': '{count} hóa đơn',
    'sales.invoice.filters.invoiceSearchPlaceholder': 'Tìm theo mã hóa đơn',
    'sales.invoice.filters.hasDebtYes': 'Còn nợ',
    'sales.invoice.filters.hasDebtNo': 'Đã thu đủ',
    'sales.invoice.statuses.draft': 'Nháp',
    'sales.invoice.statuses.completed': 'Hoàn thành',
    'sales.invoice.statuses.cancelled': 'Đã hủy',
    'sales.invoice.paymentMethods.cash': 'Tiền mặt',
    'sales.invoice.paymentMethods.card': 'Thẻ',
    'sales.invoice.paymentMethods.transfer': 'Chuyển khoản',
    'sales.invoice.actions.saveDraft': 'Lưu tạm',
    'sales.invoice.actions.complete': 'Hoàn thành',
    'sales.invoice.actions.checkout': 'Thanh toán',
    'sales.order.mobile.deliveryStep': 'Giao hàng',
    'sales.order.mobile.totalsStep': 'Tổng tiền',
    'sales.pos.mobile.catalog': 'Thực đơn',
    'sales.pos.mobile.selectedItems': 'Món đã chọn',
    'sales.pos.mobile.bill': 'Hóa đơn',
    'sales.mobile.back': 'Quay lại',
    'sales.invoice.actions.update': 'Cập nhật',
    'sales.invoice.actions.copy': 'Sao chép',
    'sales.invoice.actions.return': 'Trả hàng',
    'sales.invoice.actions.print': 'In',
    'sales.invoice.actions.cancel': 'Hủy',
    'sales.invoice.actions.cancelTitle': 'Hủy hóa đơn',
    'sales.invoice.actions.payShipping': 'Thanh toán phí giao hàng',
    'sales.invoice.actions.delete': 'Xóa',
    'sales.invoice.actions.deleteTitle': 'Xóa hóa đơn',
    'sales.invoice.actions.export': 'Xuất Excel',
    'sales.invoice.export.error': 'Không thể xuất danh sách hóa đơn.',
    'sales.invoice.actions.removeLineTitle': 'Xóa sản phẩm',
    'sales.invoice.actions.closeTab': 'Đóng đơn bán',
    'sales.invoice.actions.closeForm': 'Đóng',
    'sales.invoice.messages.cancelConfirm': 'Bạn có chắc muốn hủy hóa đơn {code}?',
    'sales.invoice.messages.shippingPaymentAmount': 'Số tiền chi cho đối tác giao hàng: {amount}',
    'sales.invoice.messages.deleteConfirm': 'Bạn có chắc muốn xóa hóa đơn {code}?',
    'sales.invoice.messages.removeLineConfirmPrefix': 'Bạn có chắc muốn xóa sản phẩm ',
    'sales.invoice.messages.removeLineConfirmSuffix': ' khỏi đơn bán?',
    'sales.invoice.messages.returnNotAvailable': 'Chưa hỗ trợ trả hàng',
    'sales.invoice.errors.missingSeller': 'Vui lòng chọn người bán.',
    'sales.invoice.errors.missingItems': 'Vui lòng chọn ít nhất một sản phẩm.',
    'sales.invoice.errors.invalidPaymentMethod':
      'Phương thức thanh toán không hợp lệ hoặc đã ngừng hoạt động.',
    'sales.invoice.errors.walkInCannotDebt':
      'Khách vãng lai không được nợ. Vui lòng thanh toán đủ số tiền hóa đơn.',
    'sales.invoice.errors.customerCreditLimitExceeded':
      'Công nợ dự kiến ({debt}) vượt hạn mức nợ của khách hàng ({limit}).',
    'sales.invoice.fields.currentCustomerDebt': 'Đang nợ',
    'sales.invoice.hints.walkInMustPayFull': 'Khách vãng lai phải thanh toán đủ, không được nợ.',
    'sales.invoice.hints.memberCanDebt':
      'Khách thành viên có thể thanh toán một phần và ghi nợ phần còn lại.',
    'sales.invoice.errors.insufficientStock': '{product} không đủ tồn kho. Tồn hiện tại: {stock}.',
    'sales.invoice.errors.unitDecimalNotAllowed':
      '{product}: đơn vị đã chọn không cho phép số lượng lẻ.',
    'sales.invoice.errors.insufficientStockItem': '- {product} (còn {stock})',
    'sales.invoice.errors.insufficientStockList': 'Các sản phẩm không đủ tồn kho:\n{products}',
    'sales.invoice.errors.locationRequired':
      'Vui lòng chọn vị trí xuất hàng cho các sản phẩm: {products}',
    'sales.invoice.errors.onlyDraftCanUpdate': 'Chỉ hóa đơn nháp mới được cập nhật.',
    'sales.invoice.errors.cancelReasonRequired': 'Lý do hủy phải có ít nhất 3 ký tự.',
    'sales.invoice.errors.cancelReasonTooLong': 'Lý do hủy không được vượt quá {max} ký tự.',
    'sales.invoice.errors.saveFailed': 'Không thể lưu hóa đơn bán hàng. Vui lòng thử lại.',
    'sales.invoice.errors.addFailed': 'Thêm hóa đơn bán hàng không thành công.',
    'sales.invoice.errors.completeFailed': 'Hoàn thành hóa đơn không thành công.',
    'sales.pos.offline.status.online': 'Trực tuyến',
    'sales.pos.offline.status.offline': 'Ngoại tuyến · {count} lệnh chờ',
    'sales.pos.offline.status.connectedOffline': 'Đã kết nối · vẫn ngoại tuyến · {count} lệnh chờ',
    'sales.pos.offline.status.syncing': 'Đang đồng bộ {completed}/{total}',
    'sales.pos.offline.status.failed': 'Đồng bộ lỗi · cần xử lý',
    'sales.pos.offline.status.connectionLost': 'Mất kết nối',
    'sales.pos.offline.status.connectionLostReady': 'Mất kết nối · sẵn sàng làm việc ngoại tuyến',
    'sales.pos.offline.banner.message':
      'Kết nối đã trở lại. Dữ liệu vẫn ở chế độ ngoại tuyến cho đến khi bạn chủ động đồng bộ.',
    'sales.pos.offline.actions.continueOffline': 'Tiếp tục ngoại tuyến',
    'sales.pos.offline.actions.workOffline': 'Làm việc ngoại tuyến',
    'sales.pos.offline.actions.switchOnline': 'Chuyển trực tuyến và đồng bộ',
    'sales.pos.offline.actions.retry': 'Thử lại',
    'sales.pos.offline.actions.editDraft': 'Sửa đơn nháp',
    'sales.pos.offline.actions.discardConflict': 'Bỏ lệnh của phiên đã đóng',
    'sales.pos.offline.actions.exportDiagnostics': 'Xuất chẩn đoán',
    'sales.pos.offline.actions.reauthenticated': 'Đã xác thực lại',
    'sales.pos.offline.commandTypes.OPEN_TABLE_SESSION': 'Mở phiên bàn',
    'sales.pos.offline.commandTypes.SAVE_TABLE_ORDER': 'Lưu đơn tại bàn',
    'sales.pos.offline.commandTypes.ADJUST_TABLE_SESSION_START_TIME': 'Chỉnh giờ vào bàn',
    'sales.pos.offline.commandTypes.CHECKOUT_TABLE_SESSION': 'Thanh toán phiên bàn',
    'sales.pos.offline.commandTypes.CANCEL_TABLE_SESSION': 'Hủy phiên bàn',
    'sales.pos.offline.commandTypes.TRANSFER_TABLE_SESSION': 'Đổi/gộp bàn',
    'sales.pos.offline.commandTypes.CREATE_BOOKING': 'Tạo đặt bàn',
    'sales.pos.offline.commandTypes.UPDATE_BOOKING': 'Cập nhật đặt bàn',
    'sales.pos.offline.commandTypes.EXTEND_BOOKING': 'Gia hạn đặt bàn',
    'sales.pos.offline.commandTypes.CANCEL_BOOKING': 'Hủy đặt bàn',
    'sales.pos.offline.commandTypes.CHECK_IN_BOOKING': 'Nhận bàn đã đặt',
    'sales.pos.offline.commandStatuses.pending': 'Đang chờ',
    'sales.pos.offline.commandStatuses.syncing': 'Đang đồng bộ',
    'sales.pos.offline.commandStatuses.acknowledged': 'Đã xác nhận',
    'sales.pos.offline.commandStatuses.failed': 'Thất bại',
    'sales.pos.offline.commandStatuses.blocked': 'Bị chặn',
    'sales.pos.offline.commandStatuses.superseded': 'Đã thay thế',
    'sales.pos.offline.dialog.title': 'Đồng bộ bán hàng ngoại tuyến',
    'sales.pos.offline.dialog.subtitle': 'Theo dõi tiến độ và xử lý dữ liệu POS chưa đồng bộ.',
    'sales.pos.offline.dialog.progress': 'Tiến độ đồng bộ',
    'sales.pos.offline.dialog.progressDetail': 'Đã hoàn tất {completed}/{total} lệnh',
    'sales.pos.offline.dialog.commands': 'Tổng lệnh',
    'sales.pos.offline.dialog.unresolved': 'Chưa hoàn tất',
    'sales.pos.offline.dialog.actionRequired': 'Cần xử lý',
    'sales.pos.offline.dialog.commandLog': 'Nhật ký đồng bộ',
    'sales.pos.offline.dialog.pending': '{count} lệnh chưa hoàn tất',
    'sales.pos.offline.dialog.billMappings': 'Mã hóa đơn đã đối chiếu',
    'sales.pos.offline.dialog.mappingPending': 'Đang chờ mã chính thức',
    'sales.pos.offline.dialog.noContext': 'Không tìm thấy ngữ cảnh ngoại tuyến.',
    'sales.pos.offline.dialog.discardConflictConfirm':
      'Phiên này đã đóng trên máy chủ. Bỏ lệnh sẽ loại bỏ các thay đổi ngoại tuyến chưa đồng bộ của phiên này. Bạn có chắc không?',
    'sales.pos.offline.dialog.table': 'Bàn {table}',
    'sales.pos.offline.branchPending':
      'Không thể đổi chi nhánh khi còn dữ liệu bán hàng ngoại tuyến chưa đồng bộ.',
    'sales.pos.offline.actorMismatch':
      'Dữ liệu ngoại tuyến đang chờ thuộc về nhân viên khác. Hãy đăng nhập lại bằng nhân viên đó để đồng bộ hoặc xử lý các lệnh đang chờ.',
    'sales.pos.offline.preparing': 'Đang tải dữ liệu ngoại tuyến…',
    'sales.pos.offline.errors.bootstrapRequired':
      'Cần kết nối mạng để tải dữ liệu ngoại tuyến lần đầu.',
    'sales.pos.offline.errors.bootstrapFailed':
      'Không tải được dữ liệu ngoại tuyến. Kiểm tra kết nối và thử lại.',
    'sales.pos.offline.errors.catalogUnavailable':
      'Không lấy được danh sách sản phẩm ngoại tuyến. Hãy đồng bộ dữ liệu offline rồi thử lại.',
    'sales.pos.offline.errors.pendingCommands':
      'Còn lệnh ngoại tuyến chưa đồng bộ. Hãy đồng bộ hoặc tiếp tục trên dữ liệu đã lưu.',
    'sales.pos.offline.errors.bundleInvalid': 'Gói dữ liệu ngoại tuyến không hợp lệ.',
    'sales.order.title': 'Đặt hàng',
    'sales.order.searchProduct': 'Tìm sản phẩm',
    'sales.order.emptyLines': 'Chưa có sản phẩm nào.',
    'sales.order.tabs.draft': 'Đơn {number}',
    'sales.order.sections.products': 'Sản phẩm',
    'sales.order.sections.summary': 'Thông tin chung',
    'sales.order.sections.delivery': 'Thông tin giao hàng',
    'sales.order.sections.package': 'Thông tin kiện hàng',
    'sales.order.sections.shipping': 'Phí giao hàng',
    'sales.order.sections.cod': 'COD',
    'sales.order.sections.totals': 'Tổng tiền',
    'sales.order.fields.orderCode': 'Mã đặt hàng',
    'sales.order.fields.orderDate': 'Thời gian đặt',
    'sales.order.fields.orderTime': 'Thời gian đặt',
    'sales.order.fields.seller': 'Nhân viên',
    'sales.order.fields.priceList': 'Bảng giá',
    'sales.order.fields.customer': 'Khách hàng',
    'sales.order.fields.product': 'Sản phẩm',
    'sales.order.fields.quantity': 'Số lượng',
    'sales.order.fields.unitPrice': 'Đơn giá',
    'sales.order.fields.discount': 'Chiết khấu',
    'sales.order.fields.lineTotal': 'Thành tiền',
    'sales.order.fields.subtotal': 'Tạm tính',
    'sales.order.fields.vatRate': 'VAT (%)',
    'sales.order.fields.vatWithRate': 'VAT ({rate}%)',
    'sales.order.fields.vatAmount': 'Tiền VAT',
    'sales.order.fields.totalAmount': 'Tổng tiền',
    'sales.order.fields.depositAmount': 'Tiền cọc',
    'sales.order.fields.depositPaymentMethod': 'Hình thức nhận cọc',
    'sales.order.fields.remainingAmount': 'Còn phải trả',
    'sales.order.fields.status': 'Trạng thái',
    'sales.order.fields.note': 'Ghi chú',
    'sales.order.fields.cancelReason': 'Lý do hủy',
    'sales.order.fields.deliveryDate': 'Ngày giao',
    'sales.order.fields.deliveryTime': 'Giờ giao',
    'sales.order.fields.recipientName': 'Người nhận',
    'sales.order.fields.recipientPhone': 'SĐT người nhận',
    'sales.order.fields.recipientAddress': 'Địa chỉ nhận',
    'sales.order.fields.deliveryPartner': 'Đơn vị vận chuyển',
    'sales.order.fields.packageWeight': 'Khối lượng',
    'sales.order.fields.packageLength': 'Chiều dài',
    'sales.order.fields.packageWidth': 'Chiều rộng',
    'sales.order.fields.packageHeight': 'Chiều cao',
    'sales.order.fields.packageQuantity': 'Số lượng',
    'sales.order.fields.packageDeclaredValue': 'Giá khai giá',
    'sales.order.fields.packageNote': 'Ghi chú kiện',
    'sales.order.fields.shippingFee': 'Phí giao hàng',
    'sales.order.fields.codEnabled': 'Bật COD',
    'sales.order.fields.codAmount': 'Số tiền COD',
    'sales.order.fields.linkedInvoice': 'Hóa đơn liên kết',
    'sales.order.shippingPayer.customer': 'Khách trả',
    'sales.order.shippingPayer.shop': 'Shop trả',
    'sales.order.shippingPayer.shared': 'Chia sẻ',
    'sales.order.statuses.draft': 'Lưu tạm',
    'sales.order.statuses.confirmed': 'Đã xác nhận',
    'sales.order.statuses.preparing': 'Đang chuẩn bị',
    'sales.order.statuses.readyToShip': 'Sẵn sàng giao',
    'sales.order.statuses.completed': 'Hoàn thành',
    'sales.order.statuses.cancelled': 'Đã hủy',
    'sales.order.statuses.expired': 'Quá hạn',
    'sales.order.actions.newOrder': 'Thêm mới',
    'sales.order.actions.saveDraft': 'Lưu tạm',
    'sales.order.actions.confirm': 'Xác nhận',
    'sales.order.actions.prepare': 'Chuẩn bị hàng',
    'sales.order.actions.readyToShip': 'Sẵn sàng giao',
    'sales.order.actions.complete': 'Hoàn thành',
    'sales.order.actions.cancel': 'Hủy',
    'sales.order.actions.cancelTitle': 'Hủy phiếu đặt hàng',
    'sales.order.actions.delete': 'Xóa',
    'sales.order.actions.deleteTitle': 'Xóa phiếu đặt hàng',
    'sales.order.actions.removeLineTitle': 'Xóa sản phẩm',
    'sales.order.actions.update': 'Cập nhật',
    'sales.order.actions.copy': 'Sao chép',
    'sales.order.actions.duplicate': 'Nhân bản',
    'sales.order.actions.print': 'In',
    'sales.order.actions.exportPdf': 'Xuất PDF',
    'sales.order.actions.createInvoice': 'Tạo hóa đơn',
    'sales.order.actions.updateInvoice': 'Cập nhật HĐ',
    'sales.order.actions.copyFromCustomer': 'Sao chép từ khách hàng',
    'sales.order.actions.closeTab': 'Đóng đơn',
    'sales.order.actions.closeForm': 'Đóng',
    'sales.order.actions.email': 'Gửi email',
    'sales.order.actions.zalo': 'Gửi Zalo',
    'sales.order.errors.missingSeller': 'Vui lòng chọn nhân viên bán hàng.',
    'sales.order.errors.missingItems': 'Vui lòng thêm ít nhất một sản phẩm.',
    'sales.order.errors.missingCustomer': 'Vui lòng chọn khách hàng.',
    'sales.order.errors.missingRecipientName': 'Vui lòng nhập tên người nhận.',
    'sales.order.errors.missingRecipientPhone': 'Vui lòng nhập số điện thoại người nhận.',
    'sales.order.errors.missingRecipientAddress': 'Vui lòng nhập địa chỉ nhận hàng.',
    'sales.order.errors.onlyDraftCanUpdate': 'Chỉ phiếu đặt hàng nháp mới được cập nhật.',
    'sales.order.errors.cancelReasonRequired': 'Lý do hủy phải có ít nhất 3 ký tự.',
    'sales.order.errors.cancelReasonTooLong': 'Lý do hủy không được vượt quá {max} ký tự.',
    'sales.order.errors.saveFailed': 'Không thể lưu phiếu đặt hàng. Vui lòng thử lại.',
    'sales.order.errors.cannotCancelCompleted': 'Không thể hủy phiếu đã hoàn thành.',
    'sales.order.errors.alreadyConverted': 'Phiếu đặt hàng đã được chuyển thành hóa đơn.',
    'sales.order.messages.cancelConfirm': 'Bạn có chắc muốn hủy phiếu đặt hàng {code}?',
    'sales.order.messages.deleteConfirm': 'Bạn có chắc muốn xóa phiếu đặt hàng {code}?',
    'sales.order.messages.convertConfirm': 'Tạo hóa đơn từ phiếu đặt hàng {code}?',
    'sales.order.messages.convertSuccess': 'Đã chuyển phiếu đặt hàng thành hóa đơn.',
    'sales.order.messages.duplicated': 'Đã nhân bản phiếu đặt hàng.',
    'sales.order.messages.selectCustomerFirst': 'Vui lòng chọn khách hàng trước.',
    'sales.order.messages.removeLineConfirmPrefix': 'Bạn có chắc muốn xóa sản phẩm ',
    'sales.order.messages.removeLineConfirmSuffix': ' khỏi phiếu đặt hàng?',
    'sales.order.filters.orderSearchPlaceholder': 'Tìm theo mã đặt hàng...',
    'sales.pos.webview.title': 'YÊU CẦU TỪ BẢNG ĐIỂM',
    'sales.pos.webview.ariaLabel': 'Thông báo order từ webview',
    'sales.pos.webview.refresh': 'Làm mới',
    'sales.pos.webview.filterTable': 'Tìm theo tên bàn…',
    'sales.pos.webview.pendingCount': '{count} yêu cầu chờ duyệt',
    'sales.pos.webview.tabPending': 'Chưa xử lý',
    'sales.pos.webview.tabAccepted': 'Đã xử lý',
    'sales.pos.webview.tabPayment': 'Yêu cầu thanh toán',
    'sales.pos.webview.tabTableEntry': 'Yêu cầu mở bàn',
    'sales.pos.webview.openTable': 'Mở bàn',
    'sales.pos.webview.willOpenTable': 'Mở bàn mới',
    'sales.pos.webview.tableOpened': 'Đã mở bàn cho {table}',
    'sales.pos.webview.accept': 'Chấp nhận',
    'sales.pos.webview.newOrder': 'Đơn mới',
    'sales.pos.webview.completedTag': 'Hoàn thành',
    'sales.pos.webview.timeJustNow': 'Vừa xong',
    'sales.pos.webview.timeMinutesAgo': '{count} phút trước',
    'sales.pos.webview.cancelOrder': 'Hủy Order',
    'sales.pos.webview.acceptAll': 'Duyệt tất cả',
    'sales.pos.webview.cancel': 'Hủy',
    'sales.pos.webview.cancelAll': 'Hủy tất cả',
    'sales.pos.webview.cancelReasonLabel': 'Lý do hủy (bắt buộc)',
    'sales.pos.webview.confirmCancel': 'Xác nhận hủy',
    'sales.pos.webview.reasonRequired': 'Vui lòng nhập lý do hủy',
    'sales.pos.webview.removeLine': 'Trừ món khỏi hóa đơn',
    'sales.pos.webview.removeReasonLabel': 'Lý do trừ món',
    'sales.pos.webview.removeLineConfirm':
      'Xóa món “{name}” đã được chấp nhận khỏi hóa đơn? Vui lòng nhập lý do.',
    'sales.pos.webview.reduceReasonDesc':
      'Có {count} món đã giảm số lượng trong hóa đơn. Nhập lý do (áp dụng cho tất cả).',
    'sales.pos.webview.confirmRemove': 'Xác nhận trừ món',
    'sales.pos.webview.removedTag': 'đã trừ',
    'sales.pos.webview.confirmPayment': 'Chấp nhận',
    'sales.pos.webview.rejectPayment': 'Từ chối',
    'sales.pos.webview.rejectReasonLabel': 'Lý do từ chối',
    'sales.pos.webview.confirmReject': 'Xác nhận từ chối',
    'sales.pos.webview.playAndContinue': 'Thanh toán & chơi tiếp',
    'sales.pos.webview.payOnly': 'Thanh toán',
    'sales.pos.webview.emptyPending': 'Không có yêu cầu gọi món nào đang chờ.',
    'sales.pos.webview.emptyAccepted': 'Chưa có order đã xử lý.',
    'sales.pos.webview.emptyPayment': 'Không có yêu cầu thanh toán nào đang chờ.',
    'sales.pos.webview.close': 'Đóng',
    'sales.pos.webview.defaultReason': 'Hủy trực tiếp tại POS',
    'sales.pos.webview.refreshFail': 'Không tải được danh sách order webview.',
    'sales.pos.webview.actionFail': 'Xử lý yêu cầu webview thất bại.',
    'sales.pos.webview.settled': 'Đã thanh toán cho {table}',
    'sales.pos.webview.settledAndReopened': 'Đã thanh toán & mở bàn mới cho {table}',
    'sales.pos.kitchen.title': 'Bếp bar',
    'sales.pos.webview.kitchen.title': 'Bếp bar',
    'sales.pos.kitchen.backToPos': 'Về bán hàng',
    'sales.pos.kitchen.completeItem': 'Hoàn thành',
    'sales.pos.kitchen.reopenItem': 'Mở lại',
    'sales.pos.kitchen.completeBill': 'Hoàn thành hoá đơn',
    'sales.pos.kitchen.allDone': 'Đã xong',
    'sales.pos.kitchen.pending': 'Đang chờ',
    'sales.pos.kitchen.inProgress': 'Đang làm',
    'sales.pos.kitchen.empty': 'Không có hoá đơn nào đang chờ bếp.',
    'sales.pos.kitchen.featureDisabled': 'Tính năng Bếp Bar đang tắt.',
    'sales.pos.kitchen.autoRefresh': 'Tự làm mới',
    'sales.pos.kitchen.progress': '{done}/{total}',
    'sales.pos.kitchen.completedBy': 'Hoàn thành bởi {name}',
    'sales.pos.kitchen.elapsed': 'Đã chơi {duration}',
    'sales.pos.kitchen.itemNote': 'Ghi chú: {note}',
    'sales.pos.kitchen.billCompleted': 'Hoá đơn đã hoàn thành',
    'sales.pos.kitchen.pendingTitle': 'Còn món chưa hoàn thành trong bếp',
    'sales.pos.kitchen.pendingMessage': 'Còn món chưa hoàn thành trong bếp',
    'sales.pos.kitchen.cancelItem': 'Hủy món',
    'sales.pos.kitchen.cancelConfirmTitle': 'Xác nhận hủy món',
    'sales.pos.kitchen.cancelConfirmMessage':
      'Bạn có chắc muốn hủy món “{name}”? Thao tác này sẽ cập nhật lại đơn hàng.',
    'sales.pos.kitchen.completeAll': 'Hoàn thành tất cả',
    'sales.pos.kitchen.payNow': 'Thanh toán',
  },
  en: {
    'setting.billiardLight.add': 'Add device',
    'setting.billiardLight.edit': 'Update light device',
    'setting.billiardLight.delete': 'Delete light device',
    'setting.billiardLight.deleteConfirm': 'Are you sure you want to delete “{name}”?',
    'setting.billiardLight.created': 'Light device added.',
    'setting.billiardLight.updated': 'Light device updated.',
    'setting.billiardLight.deleted': 'Light device deleted.',
    'setting.billiardLight.unassigned': 'Unassigned',
    'setting.billiardLight.online': 'Online',
    'setting.billiardLight.offline': 'Offline',
    'setting.billiardLight.neverConnected': 'Never connected',
    'setting.billiardLight.tokenHint': 'Leave blank to generate one on create; enter a new value to rotate it.',
    'setting.billiardLight.generatedToken': 'Save this token in the firmware. It is shown only once:',
    'setting.billiardLight.fields.name': 'Device name',
    'setting.billiardLight.fields.mac': 'ESP device MAC',
    'setting.billiardLight.fields.ip': 'IP address',
    'setting.billiardLight.fields.table': 'Assigned table',
    'setting.billiardLight.fields.connection': 'Connection',
    'setting.billiardLight.fields.light': 'Light',
    'setting.billiardLight.fields.lastSeen': 'Last connected',
    'setting.billiardLight.fields.token': 'Device security token',
    'setting.billiardLight.fields.active': 'Allow device operation',
    'sales.table.light.configure': 'Configure table light',
    'sales.table.light.mac': 'ESP device MAC',
    'sales.table.light.token': 'Device security token',
    'sales.table.light.tokenHint': 'Leave blank on first setup to generate one; enter a new value to rotate it.',
    'sales.table.light.generatedToken': 'Save this token in the firmware; it is shown only once:',
    'sales.pos.light.on': 'Light on',
    'sales.pos.light.off': 'Light off',
    'sales.pos.light.offline': 'Light offline',
    'payment.confirm.paymentInfo': 'Payment information',
    'payment.confirm.pointValue': 'Reward point value',
    'payment.confirm.actualPayer': 'Actual payer',
    'payment.confirm.customerPaidAmount': 'Customer payment',
    'payment.confirm.currencyUnit': 'VND',
    'payment.confirm.refreshPaidAmount': 'Refresh amount',
    'payment.confirm.debt': 'Amount on credit',
    'payment.confirm.change': 'Change to return',
    'payment.confirm.title': 'Confirm payment',
    'payment.confirm.orderCode': 'Order code',
    'payment.confirm.table': 'Table',
    'payment.confirm.subtotal': 'Subtotal',
    'payment.confirm.discount': 'Discount',
    'payment.confirm.vouchers': 'Applied vouchers',
    'payment.confirm.surcharge': 'Surcharge',
    'payment.confirm.total': 'Total',
    'payment.confirm.paid': 'Paid',
    'payment.confirm.remaining': 'Remaining',
    'payment.confirm.method': 'Payment method',
    'payment.confirm.payers': 'Payers',
    'payment.confirm.commonPayer': 'One payer for everyone',
    'payment.confirm.commonPayerHint':
      'Select one customer to pay the full amount owed by everyone below.',
    'payment.confirm.pointsUse': 'Points to use',
    'payment.confirm.pointsAvailable': '{points} points available',
    'payment.confirm.pointsConverted': 'Equals {amount}',
    'payment.confirm.pointsOfflineNotice':
      'Reward points are unavailable while offline. The customer pays the full amount in cash and no points are deducted.',
    'payment.confirm.errors.pointsBelowMinimum': 'Use at least {points} points for each invoice.',
    'payment.confirm.errors.pointsNotMultiple': 'Points used must be a multiple of {points}.',
    'payment.confirm.errors.insufficientPoints':
      'Total points used exceed the customer’s available balance.',
    'payment.confirm.errors.pointsAboveMaximum':
      'Use no more than {points} points for each invoice.',
    'payment.confirm.errors.pointsPercentExceeded':
      'Point value cannot exceed {percent}% of the invoice value.',
    'payment.confirm.creditLimitTitle': 'Overdue debt warning',
    'payment.confirm.creditLimitCurrentDebt': 'Current debt',
    'payment.confirm.creditLimitProjected': 'Projected debt',
    'payment.confirm.creditLimitLimit': 'Credit limit',
    'payment.confirm.creditLimitExceeded': '{debt} (over by {exceeded})',
    'payment.confirm.creditLimitOffline':
      'Debt figures come from the data downloaded for offline use and may not be the latest.',
    'payment.confirm.creditLimitBlocked':
      'Please collect enough or reduce the amount left on account before paying.',
    'payment.confirm.errors.creditLimitExceeded':
      'The projected debt for {customer} ({debt}) exceeds their credit limit ({limit}). Please collect enough or reduce the amount left on account.',
    'payment.confirm.pay': 'Pay (F2)',
    'payment.confirm.payAndPrint': 'Pay and print bill (F1)',
    'sales.pos.bookings.title': 'Table bookings',
    'sales.pos.bookings.posHint':
      'Track reserved tables, overdue guests, and check-ins directly in POS.',
    'sales.pos.bookings.create': 'Book a table',
    'sales.pos.bookings.createTitle': 'Create booking',
    'sales.pos.bookings.editTitle': 'Update booking',
    'sales.pos.bookings.detailTitle': 'Booking details',
    'sales.pos.bookings.confirm': 'Confirm booking',
    'sales.pos.bookings.search': 'Search code, customer, phone, or table',
    'sales.pos.bookings.empty': 'No matching bookings.',
    'sales.pos.bookings.pagination.total': '{total} bookings in total',
    'sales.pos.bookings.columns.booking': 'Booking and customer',
    'sales.pos.bookings.columns.tables': 'Reserved tables',
    'sales.pos.bookings.columns.actions': 'Actions',
    'sales.pos.bookings.walkIn': 'Walk-in customer',
    'sales.pos.bookings.minutesShort': 'min',
    'sales.pos.bookings.tabs.pending': 'New bookings',
    'sales.pos.bookings.tabs.confirmed': 'Confirmed',
    'sales.pos.bookings.tabs.cancelled': 'Cancelled',
    'sales.pos.bookings.status.pending': 'Pending',
    'sales.pos.bookings.status.confirmed': 'Reserved',
    'sales.pos.bookings.status.seated': 'Seated',
    'sales.pos.bookings.status.cancelled': 'Cancelled',
    'sales.pos.bookings.status.overdue': 'Overdue',
    'sales.pos.bookings.source.call': 'Phone call',
    'sales.pos.bookings.source.store': 'In store',
    'sales.pos.bookings.source.app': 'App',
    'sales.pos.bookings.deposit.cash': 'Cash',
    'sales.pos.bookings.deposit.bankTransfer': 'Bank transfer',
    'sales.pos.bookings.sections.schedule': 'Arrival schedule',
    'sales.pos.bookings.sections.customer': 'Customer information',
    'sales.pos.bookings.sections.deposit': 'Deposit and notes',
    'sales.pos.bookings.sections.tables': 'Area and tables',
    'sales.pos.bookings.sections.preorder': 'Preorder items',
    'sales.pos.bookings.steps.details': 'Details and tables',
    'sales.pos.bookings.steps.preorder': 'Choose items',
    'sales.pos.bookings.steps.continue': 'Continue',
    'sales.pos.bookings.steps.back': 'Back',
    'sales.pos.bookings.steps.finish': 'Finish',
    'sales.pos.bookings.fields.arrivalDate': 'Arrival date',
    'sales.pos.bookings.fields.arrivalTime': 'Arrival time',
    'sales.pos.bookings.fields.guestCount': 'Guest count',
    'sales.pos.bookings.fields.duration': 'Hold duration',
    'sales.pos.bookings.fields.status': 'Status',
    'sales.pos.bookings.fields.source': 'Booking source',
    'sales.pos.bookings.fields.customerName': 'Customer name',
    'sales.pos.bookings.fields.customerPhone': 'Phone number',
    'sales.pos.bookings.fields.depositAmount': 'Deposit amount',
    'sales.pos.bookings.fields.depositMethod': 'Deposit method',
    'sales.pos.bookings.fields.note': 'Special request note',
    'sales.pos.bookings.tables.multiHint': 'Select one table for each booking.',
    'sales.pos.bookings.tables.capacityWarning':
      '{seats} seats selected for {guests} guests. Consider adding another table.',
    'sales.pos.bookings.tables.seats': 'seats',
    'sales.pos.bookings.tables.selected': 'tables selected',
    'sales.pos.bookings.tables.filteredHint': 'Filtering booking list for this table',
    'sales.pos.bookings.preorder.hint':
      'Items are sent to the kitchen/bar order when the guest checks in.',
    'sales.pos.bookings.preorder.items': 'items',
    'sales.pos.bookings.preorder.selectTableFirst':
      'Select at least one table to load its catalog.',
    'sales.pos.bookings.preorder.search': 'Search food and drinks',
    'sales.pos.bookings.preorder.note': 'Item note',
    'sales.pos.bookings.preorder.productList': 'Product list',
    'sales.pos.bookings.preorder.selectedProducts': 'Selected products',
    'sales.pos.bookings.preorder.emptySelected': 'No products selected yet.',
    'sales.pos.bookings.checkIn': 'Check in',
    'sales.pos.bookings.noShow': 'No-show',
    'sales.pos.bookings.cancel.title': 'Cancel booking',
    'sales.pos.bookings.cancel.noShowTitle': 'Confirm no-show',
    'sales.pos.bookings.cancel.reason': 'Cancellation reason',
    'sales.pos.bookings.cancel.confirmAction': 'Cancel',
    'sales.pos.bookings.cancel.noShowReason': 'Guest did not arrive and could not be contacted',
    'sales.pos.bookings.cancel.depositAction': 'Deposit handling',
    'sales.pos.bookings.cancel.refundDeposit': 'Refund deposit',
    'sales.pos.bookings.cancel.retainDeposit': 'Retain deposit',
    'sales.pos.bookings.cancel.refundMethod': 'Refund method',
    'sales.order.cancel.depositAction': 'Deposit handling',
    'sales.order.cancel.refundDeposit': 'Refund deposit',
    'sales.order.cancel.retainDeposit': 'Retain deposit',
    'sales.order.cancel.refundMethod': 'Refund method',
    'sales.pos.bookings.errors.requiredFields':
      'Enter the arrival time and select at least one table.',
    'sales.pos.bookings.errors.depositMethodRequired':
      'Select a deposit method when a deposit amount is entered.',
    'sales.pos.bookings.errors.tableUnavailable':
      'A selected table now has an overlapping booking. Remove it or choose another time.',
    'sales.pos.booking.players.clearSelection': 'Clear shared item selection',
    'sales.area.fields.defaultPriceList': 'Default price list',
    'sales.tableSession.errors.saveFailed': 'Unable to update table session. Please try again.',
    'sales.tableSession.errors.cancelFailed': 'Failed to cancel table sale.',
    'sales.pos.layout.grid': 'Grid',
    'sales.pos.layout.free': 'Free',
    'sales.pos.areas.all': 'All',
    'sales.pos.bookings.upcomingWarningTitle': 'Table booking upcoming!',
    'sales.pos.bookings.upcomingWarningMessage':
      'Table {table} has a booking at {time} by {customer} ({phone}) - {guests} guests ({minutes} min left).',
    'sales.pos.bookings.upcomingWarningConfirm':
      'The booking time is approaching, do you still want to open this table?',
    'sales.pos.bookings.upcomingWarningContinue': 'Open table anyway',
    'sales.pos.bookings.upcomingBadge': 'Deposit due at {time}',
    'sales.pos.status.available': 'Available',
    'sales.pos.status.playing': 'Playing',
    'sales.pos.status.reserved': 'Reserved',
    'sales.pos.status.cleaning': 'Cleaning',
    'sales.pos.meta.notStarted': 'Not started',
    'sales.pos.billHistory.title': 'My bill history',
    'sales.pos.billHistory.shortTitle': 'My bills',
    'sales.pos.billHistory.close': 'Close bill history',
    'sales.pos.billHistory.search': 'Search',
    'sales.pos.billHistory.source': 'Sale source',
    'sales.pos.billHistory.actions': 'Actions',
    'sales.pos.billHistory.tableSale': 'Table sale',
    'sales.invoice.groups.table': 'Table',
    'sales.invoice.groups.invoiceCount': '{count} player invoices',
    'sales.invoice.fields.customer': 'Customer',
    'sales.pos.billHistory.directSale': 'Regular sale',
    'sales.pos.billHistory.reprint': 'Reprint',
    'sales.pos.billHistory.empty': 'No bills were found in the selected date range.',
    'sales.pos.billHistory.printTitle': 'PAYMENT RECEIPT',
    'sales.pos.stats.available': 'Available tables',
    'sales.pos.stats.playing': 'Playing',
    'sales.pos.stats.reserved': 'Reserved',
    'sales.pos.actions.changeTable': 'Change table',
    'sales.pos.actions.mergeTable': 'Merge table',
    'sales.pos.actions.payment': 'Payment',
    'sales.pos.actions.reserve': 'Reserve',
    'sales.pos.actions.cancelTable': 'Cancel table',
    'sales.pos.actions.cancelSessionConfirm': 'Cancel',
    'sales.pos.cancelTable.title': 'Confirm table cancellation',
    'sales.pos.cancelTable.confirm':
      'Are you sure you want to cancel {table}? A cancelled invoice will be created to record this action.',
    'sales.pos.cancelTable.reason': 'Cancellation reason',
    'sales.pos.cancelTable.reasonRequired':
      'Cancellation reason must contain at least 3 characters.',
    'sales.pos.unsavedChanges.title': 'Unsaved changes',
    'sales.pos.unsavedChanges.message':
      '{table} has changes that have not been saved. Do you want to save before continuing?',
    'sales.pos.unsavedChanges.discard': "Don't save",
    'sales.pos.startTime.action': 'Adjust table start time',
    'sales.pos.startTime.title': 'Adjust table start time',
    'sales.pos.startTime.field': 'Table start time',
    'sales.pos.startTime.timeField': 'Table start time',
    'sales.pos.startTime.reason': 'Adjustment reason',
    'sales.pos.startTime.reasonHint': 'Required, at least 5 characters.',
    'sales.pos.startTime.reasonRequired': 'The reason must contain at least 5 characters.',
    'sales.pos.startTime.pastOnly': 'Select the current time or a time in the past only.',
    'sales.pos.startTime.future': 'The table start time cannot be in the future.',
    'sales.pos.startTime.invalid': 'The table start time is invalid.',
    'sales.pos.startTime.afterPlayerJoined':
      'The table start time cannot be after a player joined.',
    'sales.pos.startTime.unavailable': 'Start-time adjustment is unavailable in the current mode.',
    'sales.pos.startTime.draftHint': 'This time will be used when the table is saved/opened.',
    'sales.pos.tableRate.action': 'Edit table rate',
    'sales.pos.tableRate.title': 'Edit table rate',
    'sales.pos.tableRate.field': 'Table rate',
    'sales.pos.tableRate.invalid': 'The table rate is invalid.',
    'sales.pos.tableRate.defaultRate': 'Current area rate: {rate}.',
    'sales.pos.booking.title': 'Book table',
    'sales.pos.booking.conflict.title': 'Order changed',
    'sales.pos.booking.conflict.message':
      'This order was changed elsewhere. Reload the latest version?',
    'sales.pos.booking.duration': 'Duration',
    'sales.pos.duration.minutes': '{minutes}m',
    'sales.pos.duration.hours': '{hours}h',
    'sales.pos.duration.hourMinutes': '{hours}h {minutes}m',
    'sales.pos.duration.dayHoursMinutes': '{days}d {hours}h {minutes}m',
    'sales.pos.booking.openSession': 'Open session',
    'sales.pos.booking.areaLabel': 'Area',
    'sales.pos.booking.areaFallback': 'POOL area',
    'sales.pos.booking.tabs.addItem': 'Add item',
    'sales.pos.booking.tabs.players': 'Players ({count})',
    'sales.pos.booking.staff': 'Handler',
    'sales.pos.booking.counterStaff': 'Counter staff',
    'sales.pos.booking.salesChannel': 'Sales channel',
    'sales.pos.booking.directSales': 'Direct sale',
    'sales.pos.booking.search': 'Search',
    'sales.pos.booking.defaultPriceList': 'General price list',
    'sales.pos.booking.stock': 'Qty',
    'sales.pos.booking.stockRemaining': '{count} left',
    'sales.pos.booking.orderedQuantity': 'Ordered {count}',
    'sales.pos.booking.productOutOfStock': 'Product is out of stock',
    'sales.pos.booking.line.pendingKitchen': 'Waiting for kitchen: {count}',
    'sales.pos.booking.searchPlaceholderShort': 'Search items...',
    'sales.pos.booking.invoiceInfo': 'Invoice information',
    'sales.pos.booking.emptyOrder': 'No items yet',
    'sales.pos.booking.close': 'Close (ESC)',
    'sales.pos.booking.update': 'Update (F1)',
    'sales.pos.booking.enterTable': 'Enter table (F1)',
    'sales.pos.booking.paymentMethod': 'Method',
    'sales.pos.booking.paymentMethods.cash': 'Cash',
    'sales.pos.booking.paymentMethods.card': 'Card',
    'sales.pos.booking.paymentMethods.transfer': 'Bank transfer',
    'sales.pos.booking.discount': 'Discount',
    'sales.pos.booking.tableDiscount': 'Table discount',
    'sales.pos.booking.summary.productTotal': 'Product total',
    'sales.pos.booking.summary.tableTotal': 'Table total',
    'sales.pos.booking.summary.discount': 'Discount',
    'sales.pos.booking.summary.tableDiscount': 'Table discount',
    'sales.pos.booking.summary.finalTotal': 'Amount due',
    'sales.pos.booking.summary.billTitle': 'Bill summary',
    'sales.pos.booking.summary.invoiceTotal': 'Invoice total',
    'sales.pos.booking.summary.tableTimeAmount': 'Table time amount',
    'sales.pos.booking.summary.tableTimeShared': 'Table time (split {count})',
    'sales.pos.booking.summary.serviceAmount': 'Service (Food / drinks)',
    'sales.pos.booking.summary.sharedService': 'Shared (split {count})',
    'sales.pos.booking.summary.paymentTotal': 'Payment total',
    'sales.pos.booking.summary.bookingDeposit': 'Booking deposit available',
    'sales.pos.booking.summary.representative': 'Booking representative',
    'sales.pos.booking.summary.amountDue': 'Amount due',
    'sales.pos.booking.summary.playerPayment': 'Pay by player',
    'sales.pos.booking.summary.playerEstimates': 'Estimate by player',
    'sales.pos.booking.summary.playerTotal': 'Total',
    'sales.pos.booking.summary.payPlayer': 'Pay',
    'sales.pos.booking.ownOrder.title': 'Select products',
    'sales.pos.booking.ownOrder.confirm': 'Confirm ({count} products)',
    'sales.pos.booking.changeTable.target': 'Choose destination table',
    'sales.pos.booking.changeTable.empty': 'No available tables to transfer',
    'sales.pos.booking.changeTable.seats': 'seats',
    'sales.pos.booking.changeTable.current': 'Current table',
    'sales.pos.booking.changeTable.new': 'New table',
    'sales.pos.booking.changeTable.notSelected': 'Not selected',
    'sales.pos.booking.changeTable.save': 'Save',
    'sales.pos.booking.changeTable.availableTitle': 'Move to an available table',
    'sales.pos.booking.changeTable.availableHint':
      'The current session ends and continues on the new table.',
    'sales.pos.booking.changeTable.errors.occupied':
      'The destination table already has a playing session.',
    'sales.pos.booking.changeTable.errors.notPlaying':
      'The destination table no longer has a playing session to merge.',
    'sales.pos.booking.changeTable.errors.versionConflict':
      'The table data changed. Reload and try again.',
    'sales.pos.booking.changeTable.errors.sourceClosed':
      'The current table session has ended or no longer exists.',
    'sales.pos.booking.changeTable.errors.sameTable':
      'The destination must be different from the current table.',
    'sales.pos.booking.changeTable.errors.unsupported':
      'Table transfer is unavailable in the current mode.',
    'sales.pos.booking.changeTable.errors.settlementLocked':
      'A table cannot be moved or merged after a partial settlement.',
    'sales.pos.booking.changeTable.errors.cooldown':
      'This table was just moved or merged. Please wait {seconds} more seconds.',
    'sales.pos.booking.changeTable.errors.cooldownGeneric':
      'Each table session can only be moved or merged once every 60 seconds.',
    'sales.pos.booking.changeTable.cooldownShort': 'Wait {seconds}s',
    'sales.pos.booking.changeTable.errors.saveFirst':
      'The current order could not be saved before transfer.',
    'sales.pos.booking.mergeTable.from': 'Merge from table',
    'sales.pos.booking.mergeTable.to': 'into table',
    'sales.pos.booking.mergeTable.notSelected': 'Not selected',
    'sales.pos.booking.mergeTable.empty': 'No playing tables to merge',
    'sales.pos.booking.mergeTable.title': 'Merge into a playing table',
    'sales.pos.booking.mergeTable.hint':
      'Table fees and items remain attributed to each session and player.',
    'sales.pos.booking.mergeTable.reverse': 'Reverse',
    'sales.pos.booking.mergeTable.confirm': 'Confirm',
    'sales.pos.booking.payAndPrint': 'Pay & Print (F2)',
    'sales.pos.booking.quickPay': 'Quick Pay (F3)',
    'sales.pos.booking.payOnly': 'Pay Only (F4)',
    'sales.pos.booking.notePlaceholder': 'Add note...',
    'sales.pos.booking.noteTitle': 'Note: {name}',
    'sales.pos.booking.editUnitPrice': 'Edit unit price',
    'sales.pos.booking.playerOne': 'Player 1',
    'sales.pos.booking.invoiceTotal': 'Total',
    'sales.pos.booking.detailTitle': 'Table details',
    'sales.pos.booking.searchPlaceholder': 'Search food and drinks...',
    'sales.pos.booking.orderedItems': 'Ordered items',
    'sales.pos.booking.orderedItemsHint': 'Tap an item to edit price, discount, and note',
    'sales.pos.booking.line.reset': 'reset',
    'sales.pos.booking.line.discountAmount': 'Amount',
    'sales.pos.booking.line.discountPercent': 'Percent',
    'sales.pos.booking.line.afterDiscount': 'Price after discount',
    'sales.pos.booking.line.notePlaceholder': 'Add a note for this item...',
    'sales.pos.booking.line.remove': 'Remove this item',
    'sales.pos.booking.order.details': 'Order details',
    'sales.pos.booking.order.note': 'Order note',
    'sales.pos.booking.order.notePlaceholder': 'Add a note for the whole order...',
    'sales.pos.booking.order.discountType': 'Discount type',
    'sales.pos.booking.order.discountValue': 'Discount value',
    'sales.pos.booking.order.tableDiscount': 'Table discount',
    'sales.pos.booking.voucherCode': 'Voucher code',
    'sales.pos.booking.voucherCodePlaceholder': 'Enter voucher code...',
    'sales.pos.booking.selectVoucher': 'Select voucher',
    'sales.pos.booking.selectVoucherPlaceholder': 'Select voucher...',
    'sales.pos.booking.voucherAppliedPercent': '{code} ({percent}% - {amount})',
    'sales.pos.booking.voucherAppliedFixed': '{code} ({value} - {amount})',
    'sales.pos.booking.voucherAppliedFixedExact': '{code} ({amount})',
    'sales.pos.booking.voucherAppliedSimple': '{code}',
    'sales.pos.booking.order.discountTypes.percent': 'Percent',
    'sales.pos.booking.order.discountTypes.amount': 'Fixed amount',
    'sales.pos.booking.order.estimatedDiscount': 'Estimated discount: {amount}',
    'sales.pos.booking.order.saveFailed': 'Unable to save the order. Please try again.',
    'sales.pos.booking.order.fixedDiscountMax': 'The maximum discount is {amount}.',
    'sales.pos.booking.order.playerRequired': 'The order must have at least one player.',
    'sales.pos.booking.sharedItems': 'Shared',
    'sales.pos.booking.hourlyRate': 'Hourly rate',
    'sales.pos.booking.actions.saveAndPrintPreview': 'Save & print estimate',
    'sales.pos.booking.actions.printPreview': 'Print estimate',
    'sales.pos.booking.actions.printBill': 'Print bill',
    'sales.pos.booking.actions.printPlayerBill': 'Print',
    'sales.pos.booking.print.tableBillTitle': 'TEMPORARY BILL',
    'sales.pos.booking.print.playerBillTitle': 'PLAYER BILL',
    'sales.pos.booking.print.paidBillTitle': 'INVOICE',
    'sales.pos.booking.print.tableTime': 'Table time fee',
    'sales.pos.booking.print.tableTimePrevious': 'Table time before transfer/merge',
    'sales.pos.booking.print.tableTimeCurrent': 'Table time at current table',
    'sales.pos.booking.print.sharedItems': 'Shared items',
    'sales.pos.booking.print.personalItems': 'Personal items',
    'sales.pos.booking.actions.changeOrMerge': 'Change/Merge table',
    'sales.pos.booking.actions.payAll': 'Pay',
    'sales.pos.booking.actions.paySelected': 'Pay selected players',
    'sales.pos.booking.actions.selectAllPayers': 'Select all players',
    'sales.pos.booking.summary.selectedTotal': 'Selected total',
    'sales.pos.booking.checkout.success': 'Payment completed successfully.',
    'sales.pos.booking.checkout.failed': 'Unable to complete payment. Please try again.',
    'sales.pos.booking.checkout.selectionRequired': 'Select at least one player to pay.',
    'sales.pos.booking.checkout.unitMissing':
      'A product is missing its unit and cannot be checked out.',
    'sales.pos.booking.checkout.sessionMissing': 'This table has no active session.',
    'sales.pos.booking.players.defaultName': 'Player {number}',
    'sales.pos.booking.players.title': 'Players',
    'sales.pos.booking.players.total': 'Players ({count})',
    'sales.pos.booking.players.selectAll': 'Select all',
    'sales.pos.booking.players.add': 'Add player',
    'sales.pos.booking.players.limitReached': 'A table can have at most {count} players',
    'sales.pos.booking.players.removeLocked': 'A player linked to settled items cannot be removed',
    'sales.pos.booking.players.customer': 'Member',
    'sales.pos.booking.players.walkInCustomer': 'Guest',
    'sales.pos.booking.players.name': 'Player name',
    'sales.pos.booking.players.unnamed': 'Unnamed',
    'sales.pos.booking.players.phone': 'Phone number',
    'sales.pos.booking.players.phoneOptional': 'Phone number (optional)',
    'sales.pos.booking.players.phoneDuplicate':
      'This phone number is already used by another player.',
    'sales.pos.booking.players.remove': 'Remove this player',
    'sales.pos.booking.players.removeConfirm':
      'Are you sure you want to remove this player from the table?',
    'sales.pos.booking.players.note': 'Player note',
    'sales.pos.booking.players.startedAt': 'Started at',
    'sales.pos.booking.players.hours': 'hours',
    'sales.pos.booking.players.minutes': 'minutes',
    'sales.pos.booking.players.estimatedAmount': 'Estimated amount',
    'sales.pos.booking.players.points': 'POINTS',
    'sales.pos.booking.players.ownOrder': 'Own order',
    'sales.pos.booking.players.sharedOrder': 'Shared',
    'sales.pos.booking.players.sharedSelection': 'Shared order',
    'sales.pos.booking.players.scrollPrevious': 'View previous players',
    'sales.pos.booking.players.scrollNext': 'View next players',
    'sales.pos.booking.players.sharedAll': 'Shared for all ({count} people)',
    'sales.pos.booking.players.joinedAt': 'Joined at {time}',
    'sales.pos.booking.players.leftAt': 'Left at {time}',
    'sales.pos.booking.players.markLeft': 'Mark as left',
    'sales.pos.booking.players.reopen': 'Reopen (keep playing)',
    'sales.pos.booking.players.settled': 'Paid',
    'sales.pos.booking.categories.all': 'All',
    'sales.pos.booking.categories.ingredients': 'INGREDIENT ORDERS',
    'sales.pos.booking.categories.mixedDrinks': 'PREPARED DRINKS',
    'sales.pos.booking.categories.accessories': 'ACCESSORIES',
    'sales.pos.booking.categories.mixedFood': 'PREPARED FOOD',
    'sales.pos.booking.categories.tableTime': 'TABLE TIME',
    'sales.pos.booking.categories.tobacco': 'TOBACCO',
    'sales.pos.booking.categories.fastFood': 'FAST FOOD',
    'sales.pos.booking.categories.quickDrinks': 'QUICK DRINKS',
    'sales.pos.booking.products.caromTable': 'CAROM 3C table',
    'sales.pos.booking.products.water': 'Water',
    'sales.pos.booking.products.soyMilk': 'Tribeco Trisoy soy milk',
    'sales.pos.booking.products.squashTea': 'Squash tea',
    'sales.pos.booking.products.c2': 'C2',
    'sales.pos.booking.products.zeroAlcohol': 'Zero Alcohol',
    'sales.pos.booking.products.nuti': 'Nuti',
    'sales.pos.booking.products.coca': 'Coca',
    'sales.pos.booking.products.fries': 'French fries',
    'sales.pos.booking.products.driedSquid': 'Dried squid',
    'sales.pos.booking.products.fishBallGarlic': 'Garlic fish balls',
    'sales.pos.booking.products.mixedFishBall': 'Mixed fish balls',
    'sales.pos.booking.products.fishNoodles': 'Fish ball noodles',
    'sales.pos.booking.products.beefNoodles': 'Beef noodles',
    'sales.pos.booking.products.eggNoodles': 'Egg noodles',
    'sales.tablePricing.actions.preview': 'Preview',
    'sales.tablePricing.errors.previewFailed': 'Unable to preview table pricing. Please try again.',
    'sales.tablePricing.preview.title': 'Table pricing preview',
    'sales.tablePricing.preview.table': 'Table',
    'sales.tablePricing.preview.source': 'Pricing source',
    'sales.tablePricing.preview.totalMinutes': 'Total minutes',
    'sales.tablePricing.preview.totalAmount': 'Total amount',
    'sales.areaPricing.model': 'area pricing policy',
    'sales.areaPricing.ruleModel': 'pricing rule',
    'sales.areaPricing.actions.add': 'Add pricing policy',
    'sales.areaPricing.actions.create': 'Create pricing policy',
    'sales.areaPricing.actions.update': 'Update pricing policy',
    'sales.areaPricing.actions.deleteTitle': 'Delete pricing policy',
    'sales.areaPricing.actions.addRule': 'Add pricing rule',
    'sales.areaPricing.actions.createRule': 'Create pricing rule',
    'sales.areaPricing.actions.updateRule': 'Update pricing rule',
    'sales.areaPricing.actions.preview': 'Preview',
    'sales.areaPricing.fields.code': 'Policy code',
    'sales.areaPricing.fields.name': 'Policy name',
    'sales.areaPricing.fields.description': 'Description',
    'sales.areaPricing.fields.rulesCount': 'Rules',
    'sales.areaPricing.fields.default': 'Default',
    'sales.areaPricing.fields.defaultLocked':
      'Set another policy as default before clearing this one.',
    'sales.areaPricing.defaultTypes.default': 'Default policy',
    'sales.areaPricing.defaultTypes.standard': 'Standard policy',
    'sales.areaPricing.fields.status': 'Status',
    'sales.areaPricing.fields.ruleName': 'Rule name',
    'sales.areaPricing.fields.timeRange': 'Time range',
    'sales.areaPricing.fields.priceAmount': 'Price',
    'sales.areaPricing.fields.priceUnit': 'Price unit',
    'sales.areaPricing.fields.pricePerMinute': 'Price/minute',
    'sales.areaPricing.fields.pricePerHour': 'Price/hour',
    'sales.areaPricing.fields.priority': 'Priority',
    'sales.areaPricing.fields.roundingPrecision': 'Rounding',
    'sales.areaPricing.fields.startTime': 'Start time',
    'sales.areaPricing.fields.endTime': 'End time',
    'sales.areaPricing.fields.daysOfWeek': 'Days',
    'sales.areaPricing.fields.startAt': 'Start',
    'sales.areaPricing.fields.endAt': 'End',
    'sales.areaPricing.priceUnits.minute': '/minute',
    'sales.areaPricing.priceUnits.hour': '/hour',
    'sales.areaPricing.preview.title': 'Area pricing preview',
    'sales.areaPricing.preview.table': 'Table',
    'sales.areaPricing.preview.totalMinutes': 'Total minutes',
    'sales.areaPricing.preview.totalAmount': 'Total amount',
    'sales.areaPricing.messages.deleteConfirm':
      'Are you sure you want to delete this pricing policy?',
    'sales.areaPricing.messages.deleteRuleConfirm':
      'Are you sure you want to delete this pricing rule?',
    'sales.areaPricing.errors.saveFailed': 'Unable to save area pricing. Please try again.',
    'sales.areaPricing.errors.endTimeAfterStart': 'End time must be later than start time.',
    'sales.area.model': 'Area',
    'sales.area.title': 'Area management',
    'sales.area.fields.branch': 'Branch',
    'sales.area.fields.code': 'Area code',
    'sales.area.placeholders.codeAuto': 'Leave blank to auto-generate',
    'sales.area.fields.name': 'Area name',
    'sales.area.fields.icon': 'Icon',
    'sales.area.fields.areaPricingPolicy': 'Area pricing policy',
    'sales.area.fields.status': 'Status',
    'sales.area.fields.sortOrder': 'Sort order',
    'sales.area.actions.add': 'Add area',
    'sales.area.actions.create': 'Add area',
    'sales.area.actions.update': 'Update area',
    'sales.area.dialog.createSubtitle': 'Add area information to the system',
    'sales.area.dialog.updateSubtitle': 'Update area information in the system',
    'sales.area.actions.submitCreate': 'Save',
    'sales.area.actions.submitUpdate': 'Save',
    'sales.area.actions.cancel': 'Cancel',
    'sales.area.actions.deleteTitle': 'Delete area',
    'sales.area.actions.import': 'Import Excel',
    'sales.area.actions.export': 'Export Excel',
    'sales.area.deleteConfirm': 'Are you sure you want to delete area {name}?',
    'sales.area.errors.saveFailed': 'Unable to save area. Please try again.',
    'sales.area.export.error': 'Unable to export the area list.',
    'sales.area.import.title': 'Import area list',
    'sales.area.import.subtitle':
      'Download the template, enter data, and validate it before saving.',
    'sales.area.import.loadingCatalog': 'Loading catalogs used to validate the import...',
    'sales.area.import.retry': 'Retry',
    'sales.area.import.templateTitle': 'Download the template',
    'sales.area.import.templateDescription':
      'The template includes instructions and valid catalog codes.',
    'sales.area.import.downloadTemplate': 'Download Excel template',
    'sales.area.import.requiredLegend': 'Required field.',
    'sales.area.import.notes.codes': 'Area code may be blank so the system can generate it.',
    'sales.area.import.notes.catalogs':
      'Use branch, price list, and pricing policy codes from the Catalog sheet.',
    'sales.area.import.notes.values':
      'Status accepts active/inactive or true/false; sort order must be a non-negative integer.',
    'sales.area.import.fileTitle': 'Choose a data file',
    'sales.area.import.fileDescription': 'Every row is validated before it is imported.',
    'sales.area.import.chooseFile': 'Choose Excel file',
    'sales.area.import.supportedFormats': 'Supports .xlsx and .xls up to 5 MB.',
    'sales.area.import.errors.invalidFileType': 'Only .xlsx or .xls Excel files are supported.',
    'sales.area.import.errors.fileTooLarge': 'The file exceeds the 5 MB limit.',
    'sales.area.import.errors.noRows': 'The file does not contain any area data rows.',
    'sales.area.import.errors.cannotRead':
      'Unable to read the file. Use the provided template and try again.',
    'sales.area.import.errors.catalogLoadFailed': 'Unable to load the area import catalogs.',
    'sales.area.import.errors.templateDownloadFailed': 'Unable to download the area template.',
    'sales.area.import.errors.rowFailed': 'Unable to create the area on this row.',
    'sales.area.import.summary.total': 'Total: {count}',
    'sales.area.import.summary.valid': 'Valid: {count}',
    'sales.area.import.summary.invalid': 'Errors: {count}',
    'sales.area.import.errorListTitle': 'Rows that need attention',
    'sales.area.import.rowLabel': 'Row {row}',
    'sales.area.import.result': 'Imported {success} areas; {failed} rows failed.',
    'sales.area.import.process': 'Import {count} areas',

    'sales.table.model': 'Table',
    'sales.table.title': 'Table management',
    'sales.table.fields.branch': 'Branch',
    'sales.table.fields.area': 'Area',
    'sales.table.fields.code': 'Table code',
    'sales.table.fields.linkCode': 'Link code',
    'sales.table.placeholders.codeAuto': 'Leave blank to auto-generate',
    'sales.table.placeholders.linkCode': 'Used for QR / Webview orders',
    'sales.table.fields.name': 'Table name',
    'sales.table.fields.pricing': 'Area pricing',
    'sales.table.fields.useAreaPricing': 'Use area pricing',
    'sales.table.options.useAreaPricingYes': 'Yes',
    'sales.table.options.useAreaPricingNo': 'No',
    'sales.table.fields.areaPricingPolicyOverride': 'Override pricing policy',
    'sales.table.fields.seats': 'Seats',
    'sales.table.fields.seatsShort': 'seats',
    'sales.table.errors.seatsMax': 'Seats cannot be greater than {max}',
    'sales.table.errors.sortOrderMax': 'Sort order cannot be greater than {max}',
    'sales.table.fields.status': 'Status',
    'sales.table.fields.sortOrder': 'Sort order',
    'sales.table.pricing.inherited': 'Inherited from area',
    'sales.table.pricing.overrideMissing': 'No override selected',
    'sales.table.actions.add': 'Add table',
    'sales.table.actions.create': 'Create table',
    'sales.table.actions.update': 'Update table',
    'sales.table.actions.submitCreate': 'Create table',
    'sales.table.actions.submitUpdate': 'Save changes',
    'sales.table.actions.cancel': 'Cancel',
    'sales.table.actions.deleteTitle': 'Delete table',
    'sales.table.actions.import': 'Import Excel',
    'sales.table.actions.export': 'Export Excel',
    'sales.table.deleteConfirm': 'Are you sure you want to delete table {name}?',
    'sales.table.errors.saveFailed': 'Unable to save table. Please try again.',
    'sales.table.export.error': 'Unable to export the table list.',
    'sales.table.import.title': 'Import table list',
    'sales.table.import.subtitle':
      'Download the template, enter data, and validate it before saving.',
    'sales.table.import.loadingCatalog': 'Loading catalogs used to validate the import...',
    'sales.table.import.retry': 'Retry',
    'sales.table.import.templateTitle': 'Download the template',
    'sales.table.import.templateDescription':
      'The template includes instructions and valid catalog codes.',
    'sales.table.import.downloadTemplate': 'Download Excel template',
    'sales.table.import.requiredLegend': 'Required field.',
    'sales.table.import.conditionalLegend': 'Required when area pricing is not used.',
    'sales.table.import.notes.codes': 'Table code may be blank so the system can generate it.',
    'sales.table.import.notes.area': 'The area code must belong to the branch on the same row.',
    'sales.table.import.notes.pricing':
      'When Use area pricing is false, an override pricing policy code is required.',
    'sales.table.import.notes.values': 'Status and Use area pricing accept Yes/No or true/false.',
    'sales.table.import.fileTitle': 'Choose a data file',
    'sales.table.import.fileDescription': 'Every row is validated before it is imported.',
    'sales.table.import.chooseFile': 'Choose Excel file',
    'sales.table.import.supportedFormats': 'Supports .xlsx and .xls up to 5 MB.',
    'sales.table.import.errors.invalidFileType': 'Only .xlsx or .xls Excel files are supported.',
    'sales.table.import.errors.fileTooLarge': 'The file exceeds the 5 MB limit.',
    'sales.table.import.errors.noRows': 'The file does not contain any table data rows.',
    'sales.table.import.errors.cannotRead':
      'Unable to read the file. Use the provided template and try again.',
    'sales.table.import.errors.catalogLoadFailed': 'Unable to load the table import catalogs.',
    'sales.table.import.errors.templateDownloadFailed': 'Unable to download the table template.',
    'sales.table.import.errors.rowFailed': 'Unable to create the table on this row.',
    'sales.table.import.summary.total': 'Total: {count}',
    'sales.table.import.summary.valid': 'Valid: {count}',
    'sales.table.import.summary.invalid': 'Errors: {count}',
    'sales.table.import.errorListTitle': 'Rows that need attention',
    'sales.table.import.rowLabel': 'Row {row}',
    'sales.table.import.result': 'Imported {success} tables; {failed} rows failed.',
    'sales.table.import.process': 'Import {count} tables',

    'sales.tablePricing.model': 'Table pricing',
    'sales.tablePricing.title': 'Table sale pricing setup',
    'sales.tablePricing.fields.branch': 'Branch',
    'sales.tablePricing.fields.area': 'Area',
    'sales.tablePricing.fields.table': 'Table',
    'sales.tablePricing.fields.tableOptional': 'Table (Optional)',
    'sales.tablePricing.fields.priceList': 'Price list',
    'sales.tablePricing.fields.priority': 'Priority',
    'sales.tablePricing.fields.status': 'Status',
    'sales.tablePricing.fields.startAt': 'Effective from',
    'sales.tablePricing.fields.endAt': 'Effective to',
    'sales.tablePricing.actions.add': 'Add table pricing',
    'sales.tablePricing.actions.create': 'Create table pricing',
    'sales.tablePricing.actions.update': 'Update table pricing',
    'sales.tablePricing.actions.submitCreate': 'Create assignment',
    'sales.tablePricing.actions.submitUpdate': 'Save changes',
    'sales.tablePricing.actions.cancel': 'Cancel',
    'sales.tablePricing.actions.deleteTitle': 'Delete table pricing',
    'sales.tablePricing.deleteConfirm':
      'Are you sure you want to delete this table pricing assignment?',
    'sales.tablePricing.errors.saveFailed': 'Unable to save table pricing setup. Please try again.',

    'sales.invoice.title': 'Sales',
    'sales.pricing.automatic': 'Automatic / General pricing',
    'sales.pricing.unavailable': 'Price list is no longer available',
    'sales.invoice.searchProduct': 'Search product',
    'sales.invoice.addSale': 'Add sale',
    'sales.invoice.tabs.draft': 'Sale {number}',
    'sales.invoice.sections.products': 'Products',
    'sales.invoice.sections.summary': 'Sale information',
    'sales.invoice.sections.totals': 'Payment',
    'sales.invoice.sections.saleType': 'Sale type',
    'sales.invoice.sections.deliveryInfo': 'Delivery information',
    'sales.invoice.saleTypes.counter': 'Counter sale',
    'sales.invoice.saleTypes.delivery': 'Delivery sale',
    'sales.invoice.fields.deliveryDate': 'Delivery date',
    'sales.invoice.fields.deliveryPartner': 'Delivery partner',
    'sales.invoice.fields.recipientName': 'Recipient',
    'sales.invoice.fields.recipientPhone': 'Recipient phone',
    'sales.invoice.fields.recipientAddress': 'Delivery address',
    'sales.invoice.fields.shippingFee': 'Shipping fee',
    'sales.invoice.fields.shippingFeePayer': 'Shipping fee payer',
    'sales.invoice.fields.customerShippingAmount': 'Customer shipping share',
    'sales.invoice.fields.shopShippingAmount': 'Shop shipping share',
    'sales.invoice.shippingPayer.customer': 'Customer pays',
    'sales.invoice.shippingPayer.shop': 'Shop pays',
    'sales.invoice.shippingPayer.shared': 'Shared',
    'sales.invoice.emptyLines': 'No products selected.',
    'sales.invoice.fields.seller': 'Seller',
    'sales.invoice.fields.priceList': 'Price list',
    'sales.invoice.fields.invoiceCode': 'Invoice code',
    'sales.invoice.fields.saleDate': 'Sale date',
    'sales.invoice.fields.saleTime': 'Sale time',
    'sales.invoice.fields.product': 'Product',
    'sales.invoice.fields.quantity': 'Quantity',
    'sales.invoice.fields.unit': 'Unit',
    'sales.invoice.fields.unitPrice': 'Unit price',
    'sales.invoice.fields.discount': 'Discount',
    'sales.invoice.fields.discountAmount': 'Discount amount',
    'sales.invoice.fields.voucherCode': 'Voucher code',
    'sales.invoice.fields.voucherDiscount': 'Voucher discount',
    'sales.invoice.fields.discountTypes.amount': 'Amount',
    'sales.invoice.fields.discountTypes.percent': 'Percent',
    'sales.invoice.fields.lineTotal': 'Line total',
    'sales.invoice.fields.subtotal': 'Subtotal',
    'sales.invoice.fields.vatRate': 'VAT (%)',
    'sales.invoice.fields.vatWithRate': 'VAT ({rate}%)',
    'sales.invoice.fields.vatAmount': 'VAT amount',
    'sales.invoice.fields.customerPayable': 'Customer payable',
    'sales.invoice.fields.totalAmount': 'Total amount',
    'sales.invoice.fields.paidAmount': 'Paid amount',
    'sales.invoice.fields.paidTotal': 'Paid',
    'sales.invoice.fields.pointPayment': 'Point payment ({points} points)',
    'sales.invoice.fields.remainingAmount': 'Remaining',
    'sales.invoice.fields.changeDueAmount': 'Change to return',
    'sales.invoice.fields.debtAmount': 'Debt amount',
    'sales.invoice.fields.paymentMethod': 'Payment method',
    'sales.invoice.fields.status': 'Status',
    'sales.invoice.fields.note': 'Note',
    'sales.invoice.fields.cancelReason': 'Cancellation reason',
    'sales.invoice.summary.pageTotal': 'Page total',
    'sales.invoice.summary.invoiceCount': '{count} invoices',
    'sales.invoice.filters.invoiceSearchPlaceholder': 'Search by invoice code',
    'sales.invoice.filters.hasDebtYes': 'Has debt',
    'sales.invoice.filters.hasDebtNo': 'Paid in full',
    'sales.invoice.statuses.draft': 'Draft',
    'sales.invoice.statuses.completed': 'Completed',
    'sales.invoice.statuses.cancelled': 'Cancelled',
    'sales.invoice.paymentMethods.cash': 'Cash',
    'sales.invoice.paymentMethods.card': 'Card',
    'sales.invoice.paymentMethods.transfer': 'Bank transfer',
    'sales.invoice.actions.saveDraft': 'Save draft',
    'sales.invoice.actions.complete': 'Complete',
    'sales.invoice.actions.checkout': 'Checkout',
    'sales.order.mobile.deliveryStep': 'Delivery',
    'sales.order.mobile.totalsStep': 'Totals',
    'sales.pos.mobile.catalog': 'Menu',
    'sales.pos.mobile.selectedItems': 'Selected items',
    'sales.pos.mobile.bill': 'Bill',
    'sales.mobile.back': 'Back',
    'sales.invoice.actions.update': 'Update',
    'sales.invoice.actions.copy': 'Copy',
    'sales.invoice.actions.return': 'Return',
    'sales.invoice.actions.print': 'Print',
    'sales.invoice.actions.cancel': 'Cancel',
    'sales.invoice.actions.cancelTitle': 'Cancel invoice',
    'sales.invoice.actions.payShipping': 'Pay delivery fee',
    'sales.invoice.actions.delete': 'Delete',
    'sales.invoice.actions.deleteTitle': 'Delete invoice',
    'sales.invoice.actions.export': 'Export Excel',
    'sales.invoice.export.error': 'Unable to export the invoice list.',
    'sales.invoice.actions.removeLineTitle': 'Remove product',
    'sales.invoice.actions.closeTab': 'Close sale',
    'sales.invoice.actions.closeForm': 'Close',
    'sales.invoice.messages.cancelConfirm': 'Are you sure you want to cancel invoice {code}?',
    'sales.invoice.messages.shippingPaymentAmount': 'Amount paid to the delivery partner: {amount}',
    'sales.invoice.messages.deleteConfirm': 'Are you sure you want to delete invoice {code}?',
    'sales.invoice.messages.removeLineConfirmPrefix': 'Are you sure you want to remove product ',
    'sales.invoice.messages.removeLineConfirmSuffix': ' from this sale?',
    'sales.invoice.messages.returnNotAvailable': 'Sales returns are not available yet.',
    'sales.invoice.errors.missingSeller': 'Please select a seller.',
    'sales.invoice.errors.missingItems': 'Please select at least one product.',
    'sales.invoice.errors.invalidPaymentMethod':
      'Payment method is invalid or has been deactivated.',
    'sales.invoice.errors.walkInCannotDebt':
      'Walk-in customers cannot leave debt. Please pay the full invoice amount.',
    'sales.invoice.errors.customerCreditLimitExceeded':
      'The projected customer debt ({debt}) exceeds the credit limit ({limit}).',
    'sales.invoice.fields.currentCustomerDebt': 'Current debt',
    'sales.invoice.hints.walkInMustPayFull':
      'Walk-in customers must pay in full and cannot leave debt.',
    'sales.invoice.hints.memberCanDebt':
      'Member customers may pay partially and leave the remainder as debt.',
    'sales.invoice.errors.insufficientStock':
      '{product} does not have enough stock. Current stock: {stock}.',
    'sales.invoice.errors.unitDecimalNotAllowed':
      '{product}: the selected unit does not allow decimal quantities.',
    'sales.invoice.errors.insufficientStockItem': '- {product} (stock: {stock})',
    'sales.invoice.errors.insufficientStockList': 'Insufficient stock for:\n{products}',
    'sales.invoice.errors.locationRequired':
      'Please select a shipping location for: {products}',
    'sales.invoice.errors.onlyDraftCanUpdate': 'Only draft invoices can be updated.',
    'sales.invoice.errors.cancelReasonRequired': 'Cancel reason must be at least 3 characters.',
    'sales.invoice.errors.cancelReasonTooLong': 'Cancel reason must not exceed {max} characters.',
    'sales.invoice.errors.saveFailed': 'Unable to save sales invoice. Please try again.',
    'sales.invoice.errors.addFailed': 'Failed to add sales invoice.',
    'sales.invoice.errors.completeFailed': 'Failed to complete sales invoice.',
    'sales.pos.offline.status.online': 'Online',
    'sales.pos.offline.status.offline': 'Offline · {count} pending',
    'sales.pos.offline.status.connectedOffline': 'Connected · continuing offline · {count} pending',
    'sales.pos.offline.status.syncing': 'Syncing {completed}/{total}',
    'sales.pos.offline.status.failed': 'Sync failed · action required',
    'sales.pos.offline.status.connectionLost': 'Connection lost',
    'sales.pos.offline.status.connectionLostReady': 'Connection lost · ready to work offline',
    'sales.pos.offline.banner.message':
      'Connectivity is back. POS remains offline until you explicitly synchronize.',
    'sales.pos.offline.actions.continueOffline': 'Continue offline',
    'sales.pos.offline.actions.workOffline': 'Work offline',
    'sales.pos.offline.actions.switchOnline': 'Switch online and sync',
    'sales.pos.offline.actions.retry': 'Retry',
    'sales.pos.offline.actions.editDraft': 'Edit draft',
    'sales.pos.offline.actions.discardConflict': 'Discard closed-session command',
    'sales.pos.offline.actions.exportDiagnostics': 'Export diagnostics',
    'sales.pos.offline.actions.reauthenticated': 'Authentication refreshed',
    'sales.pos.offline.commandTypes.OPEN_TABLE_SESSION': 'Open table session',
    'sales.pos.offline.commandTypes.SAVE_TABLE_ORDER': 'Save table order',
    'sales.pos.offline.commandTypes.ADJUST_TABLE_SESSION_START_TIME': 'Adjust table start time',
    'sales.pos.offline.commandTypes.CHECKOUT_TABLE_SESSION': 'Checkout table session',
    'sales.pos.offline.commandTypes.CANCEL_TABLE_SESSION': 'Cancel table session',
    'sales.pos.offline.commandTypes.TRANSFER_TABLE_SESSION': 'Move/merge table session',
    'sales.pos.offline.commandTypes.CREATE_BOOKING': 'Create booking',
    'sales.pos.offline.commandTypes.UPDATE_BOOKING': 'Update booking',
    'sales.pos.offline.commandTypes.EXTEND_BOOKING': 'Extend booking',
    'sales.pos.offline.commandTypes.CANCEL_BOOKING': 'Cancel booking',
    'sales.pos.offline.commandTypes.CHECK_IN_BOOKING': 'Check in booking',
    'sales.pos.offline.commandStatuses.pending': 'Pending',
    'sales.pos.offline.commandStatuses.syncing': 'Synchronizing',
    'sales.pos.offline.commandStatuses.acknowledged': 'Acknowledged',
    'sales.pos.offline.commandStatuses.failed': 'Failed',
    'sales.pos.offline.commandStatuses.blocked': 'Blocked',
    'sales.pos.offline.commandStatuses.superseded': 'Superseded',
    'sales.pos.offline.dialog.title': 'Offline POS synchronization',
    'sales.pos.offline.dialog.subtitle':
      'Track progress and resolve POS data that has not synchronized yet.',
    'sales.pos.offline.dialog.progress': 'Synchronization progress',
    'sales.pos.offline.dialog.progressDetail': '{completed} of {total} commands completed',
    'sales.pos.offline.dialog.commands': 'Total commands',
    'sales.pos.offline.dialog.unresolved': 'Unresolved',
    'sales.pos.offline.dialog.actionRequired': 'Action required',
    'sales.pos.offline.dialog.commandLog': 'Synchronization log',
    'sales.pos.offline.dialog.pending': '{count} commands are unresolved',
    'sales.pos.offline.dialog.billMappings': 'Official bill mappings',
    'sales.pos.offline.dialog.mappingPending': 'Official number pending',
    'sales.pos.offline.dialog.noContext': 'Offline context is unavailable.',
    'sales.pos.offline.dialog.discardConflictConfirm':
      'This session is already closed on the server. Discarding will remove its unsynchronized offline changes. Continue?',
    'sales.pos.offline.dialog.table': 'Table {table}',
    'sales.pos.offline.branchPending':
      'You cannot switch branch while offline POS data is still pending.',
    'sales.pos.offline.actorMismatch':
      'Pending offline data belongs to another operator. Sign in as that operator to synchronize or resolve the pending commands.',
    'sales.pos.offline.preparing': 'Downloading offline data…',
    'sales.pos.offline.errors.bootstrapRequired':
      'A network connection is required to download offline data for the first time.',
    'sales.pos.offline.errors.bootstrapFailed':
      'Unable to download offline data. Check your connection and try again.',
    'sales.pos.offline.errors.catalogUnavailable':
      'Unable to load the offline product list. Sync offline data and try again.',
    'sales.pos.offline.errors.pendingCommands':
      'Unresolved offline commands remain. Sync first or continue with the cached snapshot.',
    'sales.pos.offline.errors.bundleInvalid': 'The offline data package is invalid.',
    'sales.order.title': 'Sales Order',
    'sales.order.searchProduct': 'Search product',
    'sales.order.emptyLines': 'No products selected.',
    'sales.order.tabs.draft': 'Order {number}',
    'sales.order.sections.products': 'Products',
    'sales.order.sections.summary': 'Summary',
    'sales.order.sections.delivery': 'Delivery Information',
    'sales.order.sections.package': 'Package Information',
    'sales.order.sections.shipping': 'Shipping Fee',
    'sales.order.sections.cod': 'COD',
    'sales.order.sections.totals': 'Totals',
    'sales.order.fields.orderCode': 'Order code',
    'sales.order.fields.orderDate': 'Order time',
    'sales.order.fields.orderTime': 'Order time',
    'sales.order.fields.seller': 'Seller',
    'sales.order.fields.priceList': 'Price list',
    'sales.order.fields.customer': 'Customer',
    'sales.order.fields.product': 'Product',
    'sales.order.fields.quantity': 'Quantity',
    'sales.order.fields.unitPrice': 'Unit price',
    'sales.order.fields.discount': 'Discount',
    'sales.order.fields.lineTotal': 'Line total',
    'sales.order.fields.subtotal': 'Subtotal',
    'sales.order.fields.vatRate': 'VAT (%)',
    'sales.order.fields.vatWithRate': 'VAT ({rate}%)',
    'sales.order.fields.vatAmount': 'VAT amount',
    'sales.order.fields.totalAmount': 'Total amount',
    'sales.order.fields.depositAmount': 'Deposit amount',
    'sales.order.fields.depositPaymentMethod': 'Deposit payment method',
    'sales.order.fields.remainingAmount': 'Remaining amount',
    'sales.order.fields.status': 'Status',
    'sales.order.fields.note': 'Note',
    'sales.order.fields.cancelReason': 'Cancel reason',
    'sales.order.fields.deliveryDate': 'Delivery date',
    'sales.order.fields.deliveryTime': 'Delivery time',
    'sales.order.fields.recipientName': 'Recipient name',
    'sales.order.fields.recipientPhone': 'Recipient phone',
    'sales.order.fields.recipientAddress': 'Recipient address',
    'sales.order.fields.deliveryPartner': 'Delivery partner',
    'sales.order.fields.packageWeight': 'Weight',
    'sales.order.fields.packageLength': 'Length',
    'sales.order.fields.packageWidth': 'Width',
    'sales.order.fields.packageHeight': 'Height',
    'sales.order.fields.packageQuantity': 'Quantity',
    'sales.order.fields.packageDeclaredValue': 'Declared value',
    'sales.order.fields.packageNote': 'Package note',
    'sales.order.fields.shippingFee': 'Shipping fee',
    'sales.order.fields.codEnabled': 'Enable COD',
    'sales.order.fields.codAmount': 'COD amount',
    'sales.order.fields.linkedInvoice': 'Linked invoice',
    'sales.order.shippingPayer.customer': 'Customer',
    'sales.order.shippingPayer.shop': 'Shop',
    'sales.order.shippingPayer.shared': 'Shared',
    'sales.order.statuses.draft': 'Draft',
    'sales.order.statuses.confirmed': 'Confirmed',
    'sales.order.statuses.preparing': 'Preparing',
    'sales.order.statuses.readyToShip': 'Ready to ship',
    'sales.order.statuses.completed': 'Completed',
    'sales.order.statuses.cancelled': 'Cancelled',
    'sales.order.statuses.expired': 'Expired',
    'sales.order.actions.newOrder': 'New order',
    'sales.order.actions.saveDraft': 'Save draft',
    'sales.order.actions.confirm': 'Confirm',
    'sales.order.actions.prepare': 'Prepare',
    'sales.order.actions.readyToShip': 'Ready to ship',
    'sales.order.actions.complete': 'Complete',
    'sales.order.actions.cancel': 'Cancel order',
    'sales.order.actions.cancelTitle': 'Cancel sales order',
    'sales.order.actions.delete': 'Delete',
    'sales.order.actions.deleteTitle': 'Delete sales order',
    'sales.order.actions.removeLineTitle': 'Remove product',
    'sales.order.actions.update': 'Update',
    'sales.order.actions.copy': 'Copy',
    'sales.order.actions.duplicate': 'Duplicate',
    'sales.order.actions.print': 'Print',
    'sales.order.actions.exportPdf': 'Export PDF',
    'sales.order.actions.createInvoice': 'Create invoice',
    'sales.order.actions.updateInvoice': 'Update invoice',
    'sales.order.actions.copyFromCustomer': 'Copy from customer',
    'sales.order.actions.closeTab': 'Close order',
    'sales.order.actions.closeForm': 'Close',
    'sales.order.actions.email': 'Send email',
    'sales.order.actions.zalo': 'Send Zalo',
    'sales.order.errors.missingSeller': 'Please select a seller.',
    'sales.order.errors.missingItems': 'Please add at least one product.',
    'sales.order.errors.missingCustomer': 'Please select a customer.',
    'sales.order.errors.missingRecipientName': 'Please enter the recipient name.',
    'sales.order.errors.missingRecipientPhone': 'Please enter the recipient phone.',
    'sales.order.errors.missingRecipientAddress': 'Please enter the delivery address.',
    'sales.order.errors.onlyDraftCanUpdate': 'Only draft sales orders can be updated.',
    'sales.order.errors.cancelReasonRequired': 'Cancel reason must be at least 3 characters.',
    'sales.order.errors.cancelReasonTooLong': 'Cancel reason must not exceed {max} characters.',
    'sales.order.errors.saveFailed': 'Unable to save the sales order. Please try again.',
    'sales.order.errors.cannotCancelCompleted': 'Cannot cancel a completed order.',
    'sales.order.errors.alreadyConverted':
      'The sales order has already been converted to an invoice.',
    'sales.order.messages.cancelConfirm': 'Are you sure you want to cancel sales order {code}?',
    'sales.order.messages.deleteConfirm': 'Are you sure you want to delete sales order {code}?',
    'sales.order.messages.convertConfirm': 'Create an invoice from sales order {code}?',
    'sales.order.messages.convertSuccess': 'Converted sales order to invoice.',
    'sales.order.messages.duplicated': 'Duplicated sales order.',
    'sales.order.messages.selectCustomerFirst': 'Please select a customer first.',
    'sales.order.messages.removeLineConfirmPrefix': 'Are you sure you want to remove product ',
    'sales.order.messages.removeLineConfirmSuffix': ' from this sales order?',
    'sales.order.filters.orderSearchPlaceholder': 'Search by order code...',
    'sales.pos.webview.title': 'SCOREBOARD REQUESTS',
    'sales.pos.webview.ariaLabel': 'Webview order notifications',
    'sales.pos.webview.refresh': 'Refresh',
    'sales.pos.webview.filterTable': 'Search by table name…',
    'sales.pos.webview.pendingCount': '{count} pending requests',
    'sales.pos.webview.tabPending': 'Unprocessed',
    'sales.pos.webview.tabAccepted': 'Processed',
    'sales.pos.webview.tabPayment': 'Payment requests',
    'sales.pos.webview.tabTableEntry': 'Table entry requests',
    'sales.pos.webview.openTable': 'Open table',
    'sales.pos.webview.willOpenTable': 'Opens new table',
    'sales.pos.webview.tableOpened': 'Opened table for {table}',
    'sales.pos.webview.accept': 'Accept',
    'sales.pos.webview.acceptAll': 'Approve all',
    'sales.pos.webview.newOrder': 'New order',
    'sales.pos.webview.completedTag': 'Completed',
    'sales.pos.webview.timeJustNow': 'Just now',
    'sales.pos.webview.timeMinutesAgo': '{count}m ago',
    'sales.pos.webview.cancelOrder': 'Cancel order',
    'sales.pos.webview.cancel': 'Cancel',
    'sales.pos.webview.cancelAll': 'Cancel all',
    'sales.pos.webview.cancelReasonLabel': 'Cancel reason (required)',
    'sales.pos.webview.confirmCancel': 'Confirm cancel',
    'sales.pos.webview.reasonRequired': 'Please enter a cancel reason',
    'sales.pos.webview.removeLine': 'Remove item from bill',
    'sales.pos.webview.removeReasonLabel': 'Remove reason (required)',
    'sales.pos.webview.removeLineConfirm':
      'Remove accepted item “{name}” from the bill? Please enter a reason.',
    'sales.pos.webview.reduceReasonDesc':
      '{count} item(s) in the bill had their quantity reduced. Enter a reason (applies to all).',
    'sales.pos.webview.confirmRemove': 'Confirm remove',
    'sales.pos.webview.removedTag': 'removed',
    'sales.pos.webview.confirmPayment': 'Accept',
    'sales.pos.webview.rejectPayment': 'Reject',
    'sales.pos.webview.rejectReasonLabel': 'Reject reason',
    'sales.pos.webview.confirmReject': 'Confirm reject',
    'sales.pos.webview.playAndContinue': 'Pay & keep playing',
    'sales.pos.webview.payOnly': 'Payment',
    'sales.pos.webview.emptyPending': 'No pending order requests.',
    'sales.pos.webview.emptyAccepted': 'No processed orders.',
    'sales.pos.webview.emptyPayment': 'No pending payment requests.',
    'sales.pos.webview.close': 'Close',
    'sales.pos.webview.defaultReason': 'Canceled at POS',
    'sales.pos.webview.refreshFail': 'Could not load webview orders.',
    'sales.pos.webview.actionFail': 'Failed to process webview request.',
    'sales.pos.webview.settled': 'Payment completed for {table}',
    'sales.pos.webview.settledAndReopened': 'Paid & opened a new session for {table}',
    'sales.pos.kitchen.title': 'Kitchen',
    'sales.pos.webview.kitchen.title': 'Kitchen',
    'sales.pos.kitchen.backToPos': 'Back to sales',
    'sales.pos.kitchen.completeItem': 'Complete',
    'sales.pos.kitchen.reopenItem': 'Reopen',
    'sales.pos.kitchen.completeBill': 'Complete bill',
    'sales.pos.kitchen.allDone': 'All done',
    'sales.pos.kitchen.pending': 'Pending',
    'sales.pos.kitchen.inProgress': 'In progress',
    'sales.pos.kitchen.empty': 'No bills waiting for the kitchen.',
    'sales.pos.kitchen.featureDisabled': 'The Kitchen/Bar feature is disabled.',
    'sales.pos.kitchen.autoRefresh': 'Auto-refresh',
    'sales.pos.kitchen.progress': '{done}/{total}',
    'sales.pos.kitchen.completedBy': 'Completed by {name}',
    'sales.pos.kitchen.elapsed': 'Playing {duration}',
    'sales.pos.kitchen.itemNote': 'Note: {note}',
    'sales.pos.kitchen.billCompleted': 'Bill completed',
    'sales.pos.kitchen.pendingTitle': 'Pending kitchen items',
    'sales.pos.kitchen.pendingMessage': 'There are unfinished kitchen items.',
    'sales.pos.kitchen.cancelItem': 'Cancel item',
    'sales.pos.kitchen.cancelConfirmTitle': 'Confirm item cancellation',
    'sales.pos.kitchen.cancelConfirmMessage':
      'Are you sure you want to cancel “{name}”? This will update the order.',
    'sales.pos.kitchen.completeAll': 'Complete all',
    'sales.pos.kitchen.payNow': 'Checkout',
  },
}
